<template>
  <div>
    <b-modal id="listAttendenceswapModel" hide-footer centered size="xl" title="Attendance Swap">
      <b-form-group>
        <b-form-select placeholder="Select Faculty" v-model="attendenceSwapFilter"
          :options="attendenceSwapOptions"></b-form-select>
        <div>
          <h4>Mutual Swap</h4>
          <table class="table table-bordered table-striped">
            <tr>
              <th class="text-center" colspan="5">Sl No</th>
              <th class="text-center" colspan="40">
                Intiated by
              </th>
              <th class="text-center" colspan="40">
                Intiated for
              </th>
              <th class="text-center" colspan="10">
                Reason
              </th>
              <th class="text-center" colspan="5">
                Status
              </th>
            </tr>
            <tr>
              <th class="text-center" colspan="5">
              </th>
              <th class="text-center" colspan="8">
                Faculty
              </th>
              <th class="text-center" colspan="8">
                Date
              </th>
              <th class="text-center" colspan="8">
                Class
              </th>
              <th class="text-center" colspan="8">
                Session
              </th>
              <th class="text-center" colspan="8">
                Course
              </th>
              <th class="text-center" colspan="8">
                Faculty
              </th>
              <th class="text-center" colspan="8">
                Date
              </th>
              <th class="text-center" colspan="8">
                Class
              </th>
              <th class="text-center" colspan="8">
                Session
              </th>
              <th class="text-center" colspan="8">
                Course
              </th>
              <th class="text-center" colspan="10">
              </th>
              <th class="text-center" colspan="5">
              </th>
            </tr>
            <tr v-for="(attendence,
              attendenceIndex) in attendenceSwapArray" :key="attendenceIndex">
              <td colspan="5">{{ attendenceIndex + 1 }}</td>
              <td colspan="8">
                <p v-for="(faculty,
                  facultyIndex) in attendence['fromfaculties']" :key="facultyIndex">{{
                  faculty['first_name'] + faculty['last_name'] }}
                  <span
                    v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 0" class="text-danger">(Pending Approval)</span>
                  <span
                    v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 1">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 3">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                  <span v-if="faculty['pivot']['intiated_by'] == 1">-Intiated</span>
                </p>
              </td>
              <td colspan="8"><span v-if="attendence['from_date']">{{
                  moment(attendence['from_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="8"><span v-if="attendence['fromsubgroup']">{{ attendence['fromsubgroup']['name'] }}</span>
              </td>
              <td colspan="8"><span v-if="attendence['fromsession']">{{ attendence['fromsession']['name'] }}</span></td>
              <td colspan="8">
                <p v-for="(course,
                  cIndex) in attendence['fromcourses']" :key="cIndex">
                  {{ course['code'] }}
                </p>
              </td>
              <td colspan="8">
                <p v-for="(faculty,
                  facultyIndex) in attendence['tofaculties']" :key="facultyIndex">
                  {{ faculty['first_name'] + faculty['last_name'] }}
                  <span v-if="faculty['pivot']['approval_status'] == 0" class="text-danger">(Pending Approval)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 3">(Approved)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                  <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                </p>
              </td>
              <td colspan="8"><span v-if="attendence['to_date']">{{
                  moment(attendence['to_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="8"><span v-if="attendence['tosubgroup']">{{ attendence['tosubgroup']['name'] }}</span></td>
              <td colspan="8"><span v-if="attendence['tosession']">{{ attendence['tosession']['name'] }}</span></td>
              <td colspan="8">
                <p v-for="(course,
                  cIndex) in attendence['tocourses']" :key="cIndex">
                  {{ course['code'] }}
                </p>
              </td>
              <td colspan="10"><span v-if="attendence['reason']">{{ attendence['reason'] }}</span></td>
              <td colspan="5" class="pt-2">

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="primary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(attendence['toslot'], attendence['id'], 3)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 &&  attendence['approval_status'] == 0"
                  size="sm" variant="primary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(attendence['fromslot'], attendence['id'], 1)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 && attendence['approval_status'] == 0"
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 3 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 1 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)"
                  size="sm" variant="secondary" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 2)">Cancel</b-button>

                <span
                  v-if="attendenceSwapFilter == 5 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <span
                  v-if="attendenceSwapFilter == 4 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <!-- <span
                  v-if="attendenceSwapFilter == 1 && attendence['approval_status'] == 1 && attendence['fromintiated'] == 0" class="text-danger">Pending Approval</span> -->

                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 2">Cancelled</span>
                
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 5">Reverted</span>

                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 3">Approved <br>
                
                  <b-button 
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateAttendanceSwapStatus(null, attendence['id'], 5)">Undo</b-button>
                
                </span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 4">Rejected</span>
              </td>
            </tr>
          </table>
        </div>

        <br>
        <div class="table-responsive">
          <h4>Session Handover</h4>
          <table class="table table-bordered table-striped">
            <tr>
              <th class="text-center" colspan="5">Sl No</th>
              <th class="text-center" colspan="40">
                Intiated by
              </th>
              <th class="text-center" colspan="20">
                Intiated for
              </th>
              <th class="text-center" colspan="10">
                Reason
              </th>
              <th class="text-center" colspan="15">
                Status
              </th>
            </tr>
            <tr>
              <th class="text-center" colspan="5">
              </th>
              <th class="text-center" colspan="10">
                Faculty
              </th>
              <th class="text-center" colspan="10">
                Date
              </th>
              <th class="text-center" colspan="10">
                Class
              </th>
              <th class="text-center" colspan="10">
                Session
              </th>
              <th class="text-center" colspan="10">
                Faculty
              </th>
              <th class="text-center" colspan="10">
                course
              </th>
              <th class="text-center" colspan="10">
              </th>
              <th class="text-center" colspan="15">
              </th>
            </tr>
           <tr v-for="(attendence,
              attendenceIndex) in filteredSessionHandovers" :key="attendenceIndex">

             
              <td colspan="5">{{ attendenceIndex +1}}</td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['fromcourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['institution_user']['first_name'] + faculty['institution_user']['last_name'] }}
                    <span
                      v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 0" class="text-danger">(Pending Approval)</span>
                    <span
                      v-if="faculty['pivot']['approval_status'] == 0 && faculty['pivot']['intiated_by'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 3 || faculty['pivot']['approval_status'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                    <span v-if="faculty['pivot']['intiated_by'] == 1">-Intiated</span>
                  </p>
                </span>
              </td>
              <td colspan="10"><span v-if="attendence['from_date']">{{
                  moment(attendence['from_date'], 'YYYY-MM-DD').format('DD/MM/YYYY') }}</span></td>
              <td colspan="10"><span v-if="attendence['fromsubgroup']">{{ attendence['fromsubgroup']['name'] }}</span>
              </td>
              <td colspan="10"><span v-if="attendence['fromsession']">{{ attendence['fromsession']['name'] }}</span>
              </td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['tocourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['institution_user']['first_name'] + faculty['institution_user']['last_name'] }}
                    <span v-if="faculty['pivot']['approval_status'] == 0" class="text-danger">(Pending Approval)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 3 || faculty['pivot']['approval_status'] == 1">(Approved)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 2">(Cancelled)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 4">(Rejected)</span>
                    <span v-if="faculty['pivot']['approval_status'] == 5">(Reverted)</span>
                  </p>
                </span>
              </td>
              <td colspan="10">
                <span v-for="(faculty, facultyIndex) in attendence['tocourse_user']" :key="facultyIndex">
                  <p>
                    {{ faculty['course']['name'] + '(' + faculty['course']['code'] + ')' }}
                  </p>
                </span>
              </td>
              <td colspan="10"><span v-if="attendence['reason']">{{ attendence['reason'] }}</span></td>
              <td colspan="15">
                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="primary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['to_session_handover_approval_id'], attendence['toslot'], null, attendence['id'], 3)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['tointiated'] == 0 && attendence['tostatus'] == 0 && attendence['approval_status'] == 1"
                  size="sm" variant="danger" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || (attendence['fromintiated'] != 1 &&attendenceSwapFilter == 1)) && attendence['approval_status'] == 0"
                  size="sm" variant="primary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], attendence['fromslot'], null, attendence['id'], 1)">Approve</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 2 || attendenceSwapFilter == 1) && attendence['fromintiated'] == 0 && attendence['fromstatus'] == 0 && attendence['approval_status'] == 0"
                  size="sm" variant="danger" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 4)">Reject</b-button>

                <b-button
                  v-if="(attendenceSwapFilter == 3 || attendenceSwapFilter == 1 ) 
                  && attendence['fromintiated'] == 1 
                  && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)"
                  size="sm" variant="secondary" class="ml-4 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 2)">Cancel</b-button>

                <span
                  v-if="attendenceSwapFilter == 5 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <span
                  v-if="attendenceSwapFilter == 4 && (attendence['approval_status'] == 1 || attendence['approval_status'] == 0)" class="text-danger">Pending Approval</span>
                <!-- <span v-if="attendenceSwapFilter == 1 && attendence['approval_status'] == 1" class="text-danger">Pending Approval</span> -->
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 2">Cancelled</span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 5">Reverted</span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 3">Approved <br>
                
                  <b-button 
                  size="sm" variant="danger" class="me-2 font-weight-bolder"
                  @click="updateSessionhandoverStatus(attendence['from_session_handover_approval_id'], null, null, attendence['id'], 5)">Undo</b-button>

                </span>
                <span
                  v-if="(attendenceSwapFilter == 4 || attendenceSwapFilter == 5 || attendenceSwapFilter == 1) && attendence['approval_status'] == 4">Rejected</span>
              </td>
            </tr>
          </table>
        </div>

      </b-form-group>
    </b-modal>
    <b-modal id="mutualswapModal" @hidden="clearMultiSessionSelection" hide-footer centered size="md" title="Mutual Swap with">
      <div v-if="selectedSlots.sessions.length == 1">
        <b-form-group>
          <label class="required-label">Faculty:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select :class="{ 'form-group-error': $v.mutualswap.selectedFaculty.$error }" placeholder="Select Faculty"
              @change="mutualUserSubGroupList()" v-model="mutualswap.selectedFaculty" :options="facultyOptions">
            </b-form-select>
            <span class="input-error-message" v-if="!$v.mutualswap.selectedFaculty.required && $v.mutualswap.selectedFaculty.$dirty">Please Select a faculty!</span>
          </div>
        </b-form-group>
        <b-form-group>
          <label class="required-label">Class:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Class" v-model="mutualswap.selectedSubgroup" @change="checkClassType()" :options="subgroupOptions"></b-form-select>
            <span style="color:red" v-if="(mutualswap.selectedSubgroup != selectedSlots.subgroup_id) && mutualswap.selectedSubgroup && selectedSlots.subgroup_type == 'interdepartment_courses_group'">Mutual Swap can't support interdepartment course group</span>
            <span style="color:red" v-if="mutualswap.from_schedules_length > 1 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">Can't proceed mutual swap, Multiple faculties are mapped in from slot</span>
          </div>
        </b-form-group>
        <b-form-group v-if="selectedSlots.subgroup_type != 'interdepartment_courses_group' && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id) && mutualswap.from_schedules_length == 1">
          <label class="required-label">From Courses(slot1)</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Course" v-model="mutualswap.selectedFromCourse" :options="mutualSwapFromCourseOptions"></b-form-select>
          </div>
        </b-form-group>
        <b-form-group >
          <label class="required-label">Date:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-datepicker placeholder="Select Date" :min="mutualswapMinDate" :max="mutualswapMaxDate" @input="mutualswapSessionlist" v-model="mutualswap.selectedDate"></b-form-datepicker>
          </div>
        </b-form-group>
        <span style="color:red" v-if="sessionOptions.length == 0 && mutualswap.selectedDate">The selected faculty does not have session assigned on {{ mutualswap.selectedDate }}</span>
        <b-form-group v-if="sessionOptions.length>0 && mutualswap.selectedDate && (mutualswap.selectedSubgroup==selectedSlots.subgroup_id || selectedSlots.subgroup_type!='interdepartment_courses_group')">
          <label class="required-label">Session:</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select :class="{ 'form-group-error': $v.mutualswap.selectedSession.$error }" placeholder="Select Session" @change="checkSessionSwapped()" v-model="mutualswap.selectedSession" :options="sessionOptions"></b-form-select>
            <span class="input-error-message" v-if="!$v.mutualswap.selectedSession.required && $v.mutualswap.selectedSession.$dirty">Please Select a session!</span>
          </div>
        </b-form-group>

        <span class="text-danger" v-if="mutualswap.selectedSession && mutualswap.swapped_session == 1">
          This session has already been swapped.
        </span>

        <span style="color:red" v-if="mutualswap.to_schedules_length > 1 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">Can't proceed mutual swap, Multiple faculties are mapped in to slot</span>
        <b-form-group v-if="selectedSlots.subgroup_type != 'interdepartment_courses_group' && sessionOptions.length > 0 && mutualswap.selectedSubgroup && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)">
          <label class="required-label">To Courses(slot2)</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-select placeholder="Select Course" v-model="mutualswap.selectedToCourse" :options="mutualSwapToCourseOptions"></b-form-select>
          </div>
        </b-form-group>
        <b-form-group v-if="(mutualswap.selectedSubgroup != selectedSlots.subgroup_id && mutualswap.to_schedules_length == 1 && sessionOptions.length > 0 && mutualswap.selectedSubgroupType != 'interdepartment_courses_group') || (mutualswap.selectedSubgroup == selectedSlots.subgroup_id && sessionOptions.length > 0 && mutualswap.selectedSubgroupType != 'interdepartment_courses_group')">
          <label class="required-label">Reason(minimum 10 character):</label>
          <div class="p-2" style="border: 2px solid #eeeeeb; border-left-style: none; border-right-style: none;">
            <b-form-input :class="{ 'form-group-error': $v.mutualswap.reason.$error }" placeholder="Enter Reason" v-model="mutualswap.reason"></b-form-input>
            <span class="input-error-message" v-if="!$v.mutualswap.reason.required && $v.mutualswap.reason.$dirty">Please Enter reason!</span>
          </div>
        </b-form-group>

        <div class="d-flex justify-content-between" v-if="sessionOptions.length > 0 && ((mutualswap.selectedSubgroup==selectedSlots.subgroup_id || selectedSlots.subgroup_type!='interdepartment_courses_group'))">
          <span v-if="swapRequestSave" class="text-success">Swap Request Saving..........</span>
          <b-button class="btn btn-success" size="sm" @click="initiateSwapRequest()" 
          :disabled="mutualswap.swapped_session == 1 || swapRequestSave ||!mutualswap.reason || (mutualswap.reason && mutualswap.reason.length < 10) || (mutualswap.to_schedules_length > 1 && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id)) || (mutualswap.from_schedules_length > 1 && (mutualswap.selectedSubgroup != selectedSlots.subgroup_id))">Initiate Swap Request</b-button>
          <b-button @click="$bvModal.hide('mutualswapModal')" variant="danger" size="sm">Cancel</b-button>
        </div>

      </div>
      <span v-else>Mutual swap/session handover will not work for multiple sessions</span>
    </b-modal>

    <b-modal id="sessionHandoverModal" @hidden="clearMultiSessionSelection" hide-footer centered size="md" title="Session Handover for">
      <div v-if="selectedSlots.sessions.length == 1">
        <b-form-group>
          <label class="required-label">Course and Faculty</label>
          <div class="row">
            <div class="col-sm-6 col-md-4 col-lg-3" v-for="courseInstructor in courseInstructorArray"
              :key="courseInstructor.course_user_id">
              <b-form-checkbox v-if="!courseInstructor.course_user_deleted_at" v-model="sessionhandover.course_user_ids" :value="courseInstructor.course_user_id"
                @change="updateSessioncourseuserid(courseInstructor.course_user_id)"> {{
                  courseInstructor.course_code }}-<small>{{
                  courseInstructor.instructor
                }}</small>
              </b-form-checkbox>
            </div>
            <br />
          </div>
        </b-form-group>
        <b-form-group>
          <label class="required-label">Reason(minimum 10 character):</label>
          <div style="
              border: 2px solid #eeeeeb;
              border-left-style: none;
              border-right-style: none;
            " class="p-2">
            <b-form-input placeholder="Enter Reason" v-model="sessionhandover.reason"></b-form-input>
          </div>
        </b-form-group>
        <div class="d-flex justify-content-between">
          <b-button class="btn btn-success"
            :disabled="!sessionhandover.reason || (sessionhandover.reason && sessionhandover.reason.length < 10)"
            size="sm" @click="sessionhandoverRequest()">Intiate Session handover Request</b-button>
          <b-button @click="$bvModal.hide('sessionHandoverModal')" variant="danger" size="sm">Cancel</b-button>
        </div>
      </div>
      <span v-else>Mutaual swap/session handover will not work for multiple session </span>
    </b-modal>

    <b-col sm="12">

      <div class="row justify-content-center">
        <div class="attendance-table-container">
          <b-col class="border border-dark py-2">
            <div>
              <b-row class="d-flex justify-content-between">
                <ul>
                  <li style="border:none;">Update Work Log? <b-link @click="openWorkLogList()"> Click here to proceed</b-link>
                  </li>
                  <li style="border:none;">Download work log report <b-link @click="$bvModal.show('workLogReportModal')"> Click to download</b-link>
                  </li>
                  <li style="border:none;">Mark Attendance Using Calender? <b-link
                      @click="$bvModal.show('customDateAttendanceMarkModel')"> Click here to proceed</b-link>
                  </li>
                  <li style="border:none;">Swap Session/Session Handover Log? <b-link @click="attendenceSwapList()"> Click
                      here to proceed</b-link>
                  </li>
                  <li style="border:none;">Want To Edit/Delete Attendance? <b-link
                      @click="openEditCourseAttendanceFormWithReportMainTab"> Click here to proceed</b-link>
                  </li>
                  <li style="border:none;">Download my schedule pdf report<b-link @click="downloadMySchedulePdf">
                      {{ loadingPdf ? 'Please wait...' : 'Click to download' }}</b-link>
                  </li>
                  <li style="border:none;">View my full schedule <b-link @click="openFullSchedule"> Click to view</b-link>
                  </li>
                </ul>

                <ul class="mr-2">
                  <li style="border:none; margin-bottom: 1px;"> <span class="px-3  mr-1 border-success"
                      style="border: 2px solid ;"></span>Scheduled, Attendance Marked
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-danger"
                      style="border: 2px solid;"></span>Scheduled, Attendance Not Marked
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-warning"
                      style="border: 2px solid ;"></span>Scheduled, Attendance Marked by Another Faculty
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3  mr-1 border-info"
                      style="border: 2px solid ;"></span>Not Scheduled, Attendance Marked.
                  </li>

                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3 holiday-schedule  mr-1 border-dark"
                      style="border: 2px solid;"></span>Holiday.
                  </li>
                  <li style="border:none;margin-bottom: 1px;"> <span class="px-3 suspended-schedule  mr-1 border-dark"
                      style="border: 2px solid;"></span>Class Suspended.
                  </li>
                </ul>
              </b-row>
              <b-modal id="customDateAttendanceMarkModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                hide-header-close hide-footer hide-header centered size="md">
                <customDateAttendanceMarking :sessionsProp="sessions"
                  @markNewAttendance="markNewAttendanceFromCustomDate" />
              </b-modal>
              <b-modal id="unlockAttendanceModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                hide-header-close hide-footer hide-header centered size="md">
                <div>
                  <b-col sm="12">
                    <h3 style="text-align: center; font-size:18px !important;">
                      Unlock Attendance
                    </h3>
                    <b-form-group>
                      <label class="required-label" for="">Reason (Minimum 10 character):</label>
                      <b-form-input id="input-1" v-model="unlock_reason" type="text"
                        placeholder="Enter Reason"></b-form-input>
                    </b-form-group>
                    <b-button @click="$bvModal.hide('unlockAttendanceModel')" class="mr-3"
                      variant="danger">Cancel</b-button>
                    <b-button class="ml-2" variant="success" :disabled="!enable_unlock_proceed || (unlock_reason && unlock_reason.length < 10)"
                      size="sm" @click="submitattendanceunlock()">Proceed</b-button>
                  </b-col>
                </div>
              </b-modal>
              <b-modal id="slotCoursePickerModel" hide-footer hide-header centered size="md">
                <div v-if="slotPicker.date">
                  <div class="d-flex justify-content-between align-items-center">
                    <h3 style="font-size:18px !important;" class="mb-0">
                      {{ slotPicker.sessionIds.length > 1 ? 'Sessions' : 'Session' }} {{ sessionNames(slotPicker.sessionIds) }}
                    </h3>
                    <span class="text-muted">{{ moment(slotPicker.date, 'YYYY-MM-DD').format('ddd, DD MMM') }}</span>
                  </div>
                  <p class="mb-3" style="font-size: 13px;">
                    {{ slotPicker.entries.length }}
                    {{ slotPicker.sessionIds.length > 1 ? 'common' : '' }}
                    {{ slotPicker.entries.length == 1 ? 'course' : 'courses' }}
                    {{ slotPicker.sessionIds.length > 1 ? '' : 'in this slot' }} — pick one to mark attendance
                  </p>
                  <!-- like the app: tapping a subject goes straight to marking; a
                       locked one shows its unlock request instead. Swap and
                       handover sit below each subject. -->
                  <div v-for="(entry, entryIndex) in slotPicker.entries" :key="entryIndex"
                    class="slot-picker-card">
                    <div class="slot-picker-item" @click="slotEntryClick(entry, entryIndex)">
                      <div style="min-width: 0;">
                        <div class="font-weight-bold text-dark" style="font-size: 15px;">
                          {{ slotEntryLabel(entry) }}
                          <span v-if="entry.schedule && entry.schedule.swapped == 1">-Swapped</span>
                          <span v-if="entry.schedule && entry.schedule.handover == 1">-Session handover</span>
                        </div>
                        <div style="font-size: 12px;">
                          <span v-if="entry.schedule" class="font-weight-bold mr-2">{{ entry.schedule.class_type || 'Regular' }}</span>
                          <span v-if="entry.schedule && entry.schedule.delivery_method" class="mr-2" style="color: blue;">{{ entry.schedule.delivery_method }}</span>
                          <span class="text-muted mr-2">{{ courses[entry.courseId].usersubgroup.usergroup.name }}</span>
                          <span class="font-weight-bold" :class="slotEntryColor(entry)">{{ slotEntryStatus(entry) }}</span>
                        </div>
                        <!-- this subject's own lock / unlock request status, gathered
                             from every chosen session; the sessions are named when they differ -->
                        <div v-if="entry.schedule && (entry.lockedSessions.length || entry.pendingSessions.length || entry.unlockedSessions.length)" class="mt-1" style="font-size: 12px;">
                          <span v-if="entry.unlockedSessions.length" class="text-success mr-2">Unlocked<template
                              v-if="entry.lockMixed"> ({{ sessionNames(entry.unlockedSessions) }})</template></span>
                          <span v-if="entry.pendingSessions.length" class="text-info mr-2">Locked, unlock request pending<template
                              v-if="entry.lockMixed"> ({{ sessionNames(entry.pendingSessions) }})</template></span>
                          <span v-if="entry.lockedSessions.length" class="text-info mr-2">Locked<template
                              v-if="entry.lockMixed"> ({{ sessionNames(entry.lockedSessions) }})</template></span>
                        </div>
                      </div>
                      <i class="fas fa-chevron-right text-muted"></i>
                    </div>
                    <!-- locked subject tapped: its unlock request -->
                    <div v-if="entryIndex == slotPicker.chosenIndex" class="px-3 pb-2" style="font-size: 13px;">
                      <span v-if="entry.lockMixed" class="text-danger">
                        Lock status differs across the selected sessions. Please select them individually.
                      </span>
                      <span v-else class="text-info">
                        Attendance locked for this session.<span v-if="!entry.schedule.pending">Send Unlock Request?</span>
                        <span v-else>Unlock request is pending</span>
                        <b-button v-if="!entry.schedule.pending" class="ml-2" variant="success" size="sm"
                          @click="requestSlotEntryUnlock(entry)">Unlock</b-button>
                      </span>
                    </div>
                    <!-- swap / handover, same rules as the header -->
                    <div v-if="entry.schedule" class="px-3 pb-2" style="font-size: 12px;">
                      <span v-if="!entry.schedule.swapped && !entry.schedule.handover">
                        <b-button v-if="!entry.schedule.swap_pending && entry.schedule.attendance_status === ''"
                          class="mr-2" variant="primary" size="sm" @click="slotEntryAction(entry, 'swap')">Initiate Mutual Swap</b-button>
                        <span v-else-if="entry.schedule.swap_pending" class="text-danger mr-2">Swap request cannot be initiated because a request is already pending.</span>
                        <b-button v-if="!entry.schedule.handover_pending && entry.schedule.attendance_status === ''"
                          variant="primary" size="sm" @click="slotEntryAction(entry, 'handover')">Initiate Session Handover</b-button>
                        <span v-else-if="entry.schedule.handover_pending" class="text-danger">Session handover request cannot be initiated because a request is already pending.</span>
                      </span>
                      <span v-else>
                        <span class="text-success mr-2" v-if="entry.schedule.swapped">Already Swapped</span>
                        <span class="text-success" v-if="entry.schedule.handover">Session already handed over.</span>
                      </span>
                    </div>
                  </div>
                  <!-- work logs of the chosen sessions, view only -->
                  <template v-for="sessionId in slotPicker.sessionIds">
                    <div v-if="workLogs[workLogKey(slotPicker.date, sessionId)]" :key="'workLog' + sessionId"
                      class="slot-picker-card slot-picker-work-log">
                      <div class="slot-picker-item" style="cursor: default;">
                        <div style="min-width: 0;">
                          <div class="font-weight-bold" style="font-size: 15px; color: #6f42c1;">
                            Work Log<span v-if="slotPicker.sessionIds.length > 1"> - {{ sessionNames([sessionId]) }}</span>
                            <span v-if="workLogs[workLogKey(slotPicker.date, sessionId)].time" style="font-size: 12px;">
                              ({{ workLogTime(workLogs[workLogKey(slotPicker.date, sessionId)]) }})</span>
                          </div>
                          <div class="text-muted" style="font-size: 12px; white-space: pre-line;">
                            {{ workLogs[workLogKey(slotPicker.date, sessionId)].description }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div class="text-right mt-3">
                    <b-button @click="$bvModal.hide('slotCoursePickerModel')" variant="danger" size="sm">Cancel</b-button>
                  </div>
                </div>
              </b-modal>
            </div>
            <h5 class="text-center" style="font-size:16px !important; color: #010177;">
              My Schedule
            </h5>
          </b-col>
          <table v-if="(viewMySchedule === true)" class="table table-bordered black-border "
            style="width: auto !important; text-align: center;">
            <thead style="position: sticky;top: 0;">
              <tr>
                <th :colspan="(mySchedulesEnabledSessionIds.length + 1)" style="color: #000950;"
                  class="text-center  bg-white">
                  <!-- cells with several subjects chosen: Proceed picks the subject -->
                  <span v-if="pendingSlots.sessions.length > 0">
                    <i class="blink_me fas fa-calendar mr-3"></i>
                    Mark attendance for {{ chosenSessionIds().length > 1 ? 'sessions' : 'session' }}
                    {{ sessionNames(chosenSessionIds()) }}
                    on {{ moment(pendingSlots.date, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
                    <b-button class="ml-2" variant="success" size="sm" @click="openCoursePicker">Proceed</b-button>
                    <b-button class="ml-2" variant="secondary" size="sm" @click="clearPendingSlots(); clearSlotSelection(); $forceUpdate()">Close</b-button>
                  </span>
                  <template v-else>
                  <span v-if="selectedSlots.course_id == ''">Please choose slots to mark attendance - swap session</span>


                  <span v-if="!selectedSlots.swapped && !selectedSlots.handover">
                    <span v-if="!selectedSlots.swap_pending">
                      <b-button v-if="selectedSlots.course_id != '' && !selectedSlots.already_marked" style="margin-right:10px;" class="ml-2" variant="primary" size="sm" @click="showMutualSwapPopup()">Initiate Mutual Swap</b-button>
                    </span>
                    <span v-else-if="selectedSlots.course_id != ''" class="text-danger">Swap request cannot be initiated because a request is already pending.<br></span>

                    <span v-if="!selectedSlots.handover_pending">
                      <b-button v-if="selectedSlots.course_id != '' && !selectedSlots.already_marked" style="margin-right:10px;" class="ml-2" variant="primary" size="sm" @click="sessionHandover()">Initiate Session Handover</b-button>
                    </span>
                    <span v-else-if="selectedSlots.course_id != ''" class="text-danger">Session handover request cannot be initiated because a request is already pending.<br></span>
                  </span>
                  <span v-else>
                    <span class="text-success" v-if="selectedSlots.course_id != '' && selectedSlots.swapped">Already Swapped</span>    
                    <span class="text-success" v-if="selectedSlots.course_id != '' && selectedSlots.handover">Session already handed over.</span>
                  </span>

                  <span v-if="selectedSlots.course_id != ''&& !selectedSlots.lock">
                    <span class="text-info" v-if="selectedSlots.holiday">This date is already marked as holiday. Do you
                      still want to proceed with attendance marking?<br></span>
                    <span class="text-info" v-if="selectedSlots.suspend">This session has already been suspended. Do you
                      still want to proceed with attendance marking?<br></span>
                    <i class="blink_me fas fa-calendar mr-3"></i>

                    <!-- same message as for cells with several subjects -->
                    Mark attendance for {{ selectedSlots.sessions.length > 1 ? 'sessions' : 'session' }}
                    {{ sessionNames(mySchedulesEnabledSessionIds.filter(id => selectedSlots.sessions.includes(id))) }}
                    on {{ moment(selectedSlots.date, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
                    <b-button class="ml-2" variant="success" size="sm" @click="markNewAttendance">Proceed</b-button>
                  </span>
                  <span v-if="selectedSlots.course_id != '' &&  selectedSlots.lock">
                    <span class="text-info">Attendance locked for this session.<span
                        v-if="!selectedSlots.unlock_Pending">Send Unlock Request?</span>
                      <span v-else>Unlock request is pending</span>
                    </span>
                    <b-button class="ml-2" variant="success" size="sm" v-if="!selectedSlots.unlock_Pending"
                      @click="$bvModal.show('unlockAttendanceModel')">Unlock</b-button>
                  </span>
                  </template>
                  <span v-b-tooltip.hover :title="'Refresh Schedule Table'" style="float: right;"
                    @click="getMySchedulesAttendances()">
                    <i class="fas fa-sync"></i>
                  </span>

                </th>
              </tr>
              <tr>
                <th class="text-center text-white bg-dark" style="min-width: 100px;">
                  <i class="fas fa-user-clock fa-lg"></i>
                </th>
                <th v-for="sessionId in mySchedulesEnabledSessionIds" :key="sessionId" style="width: 150px; min-width: 150px; max-width: 150px;"
                  class="text-center text-white bg-dark">
                  {{ sessionObjects[sessionId].name }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(sessionsScheduleAtts, date, index) in dateSessionScheduleAtts"
                :ref="(new Date().toISOString().slice(0, 10) == date) ? 'todaySchedule' : ''" :key="date" :style="index === 0 && localYMD(date) > localYMD(new Date()) ? { filter: 'grayscale(100%)', opacity: '0.6', pointerEvents: 'none' } : {}">
                <td>
                  {{ moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') }} <br>{{ weekdayNames[new Date(date).getDay()] }}
                </td>
                <td
                  :class="{ 'selected-slot': (selectedSlots.sessions.includes(sessionId) && selectedSlots.date == date) || isPendingSlot(date, sessionId) }"
                  v-for="sessionId in mySchedulesEnabledSessionIds" :key="sessionId" class="schedule-cell">
                  <!-- first subject of the slot + "N more"; more than one opens a picker -->
                  <div v-for="(entries, entriesIndex) in [slotEntries(sessionsScheduleAtts[sessionId])]" :key="entriesIndex"
                    v-show="entries.length > 0" class="schedule-cell-content"
                    :class="slotEntryBackground(entries[0])"
                    @click="openSlot(entries, date, sessionId)"
                    v-b-popover.hover.top="entries.length == 1 ? slotEntryDetails(entries[0]) + slotWorkLogDetails(date, sessionId) : ''">
                    <!-- subject + count of the rest on one line; a work log with a subject
                         is counted here instead of its own label -->
                    <div v-if="entries.length > 0" class="schedule-cell-label schedule-cell-row" :class="slotEntryColor(entries[0])">
                      <span class="schedule-cell-name">{{ slotEntryLabel(entries[0]) }}</span>
                      <span v-if="slotMoreCount(entries, date, sessionId) > 0" class="schedule-cell-count">
                        +{{ slotMoreCount(entries, date, sessionId) }}</span>
                    </div>
                    <!-- swap / handover status with the subject, on its own line so a
                         long subject name can't cut it off -->
                    <div v-if="entries.length > 0 && entries[0].schedule && (entries[0].schedule.swapped == 1 || entries[0].schedule.handover == 1)"
                      class="schedule-cell-more" :class="slotEntryColor(entries[0])">
                      {{ entries[0].schedule.swapped == 1 ? 'Swapped' : 'Session handover' }}
                    </div>
                  </div>
                  <!-- saved work log of a slot with no subject, view only -->
                  <div v-if="workLogs[workLogKey(date, sessionId)] && slotEntries(sessionsScheduleAtts[sessionId]).length == 0"
                    class="schedule-work-log" @click.stop
                    v-b-popover.hover.top="workLogDetails(workLogs[workLogKey(date, sessionId)])" title="Work Log">
                    Work Log<span v-if="workLogs[workLogKey(date, sessionId)].time">
                      - {{ workLogTime(workLogs[workLogKey(date, sessionId)]) }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center" :class="viewLoadMore ? '' : 'd-none'">
            <button class="btn btn-secondary" :class="isLoadingMore == null ? 'd-none' : ''" @click="getMySchedulesAttendances(true)"> {{ isLoadingMore ? 'Loading…' : 'Load More' }}</button>
          </div>
        </div>
      </div>
      <div v-if="(viewMySchedule === null)">Loading Schedules...</div>
      <div v-if="viewMySchedule === false" class="text-danger text-center py-2">
        <b>Timetable is not updated by Faculty adviser</b>
      </div>

    </b-col>
    <!-- whole schedule on one page, no Load More / date range; view only -->
    <!-- work log list, full page -->
    <b-modal id="workLogListModal" hide-footer title="Work Log" modal-class="usersListPendingFull">
      <div class="d-flex justify-content-start mb-3">
        <b-button variant="primary" size="sm" @click="openWorkLog()">
          <i class="fas fa-plus mr-1"></i> Add Work Log
        </b-button>
      </div>
      <div v-if="workLogListLoading" class="text-center py-3">Loading...</div>
      <div v-else-if="workLogList.length < 1" class="text-center text-muted py-3">No work log added yet.</div>
      <table v-else class="table table-striped table-bordered">
        <thead class="thead-dark">
          <tr>
            <th style="width: 50px;">#</th>
            <th style="width: 120px;">Date</th>
            <th style="width: 150px;">Session</th>
            <th style="width: 190px;">Time</th>
            <th>Description</th>
            <th style="width: 60px;" class="text-center">Edit</th>
            <th style="width: 70px;" class="text-center">Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in workLogList" :key="log.id">
            <td>{{ index + 1 }}</td>
            <td>{{ moment(log.date, 'YYYY-MM-DD').format('DD/MM/YYYY') }}</td>
            <td>{{ sessionObjects[log.session_id] ? sessionObjects[log.session_id].name : '' }}</td>
            <td>{{ workLogTime(log) }}</td>
            <td style="white-space: pre-line;">{{ log.description }}</td>
            <td class="text-center">
              <span class="btn m-0 p-0 text-info" title="Edit" @click="openWorkLog(log.date, log.session_id)">
                <i class="far fa-edit"></i>
              </span>
            </td>
            <td class="text-center">
              <span v-if="deletingWorkLogId == log.id" class="text-muted" style="font-size: 12px;">Deleting...</span>
              <span v-else class="btn p-0 m-0 text-danger" title="Delete" @click="deleteWorkLog(log)">
                <i class="fas fa-trash"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>

    <!-- work log report: pick the date range -->
    <b-modal id="workLogReportModal" hide-footer centered title="Download Work Log Report">
      <b-row>
        <b-col md="6">
          <label class="work-log-label">From</label>
          <b-form-datepicker v-model="workLogReport.from" placeholder="Select Date" :max="workLogReport.to"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }" locale="en-GB"></b-form-datepicker>
        </b-col>
        <b-col md="6">
          <label class="work-log-label">To</label>
          <b-form-datepicker v-model="workLogReport.to" placeholder="Select Date" :min="workLogReport.from"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }" locale="en-GB"></b-form-datepicker>
        </b-col>
      </b-row>
      <small class="text-muted d-block mt-2">Leave the dates empty to download all work logs.</small>
      <div class="text-right mt-3">
        <b-button variant="secondary" size="sm" @click="$bvModal.hide('workLogReportModal')">Cancel</b-button>
        <b-button variant="primary" size="sm" class="ml-2" :disabled="workLogReport.loading"
          @click="downloadWorkLogReport()">{{ workLogReport.loading ? 'Please wait...' : 'Download' }}</b-button>
      </div>
    </b-modal>

    <!-- add / edit work log -->
    <b-modal id="workLogModal" hide-footer centered size="lg"
      :title="workLogEntries.length == 1 && workLogEntries[0].id ? 'Edit Work Log' : 'Add Work Log'">
      <!-- one block per work log, saved together -->
      <div v-for="(entry, entryIndex) in workLogEntries" :key="entry.key"
        :class="{ 'work-log-entry': workLogEntries.length > 1 }">
        <div v-if="workLogEntries.length > 1" class="work-log-entry-head">
          <span class="work-log-entry-number">{{ entryIndex + 1 }}</span>
          <span class="work-log-entry-title">Work Log {{ entryIndex + 1 }}</span>
          <span v-if="entry.id" class="work-log-entry-tag">Editing saved log</span>
          <button type="button" class="work-log-remove" v-b-tooltip.hover title="Remove"
            @click="removeWorkLogEntry(entryIndex)">
            <i class="fas fa-trash"></i>
          </button>
        </div>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label class="work-log-label">Date</label>
              <b-form-datepicker placeholder="Select Date" v-model="entry.date" @input="fillExistingWorkLog(entry)"
                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }">
              </b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label class="work-log-label">Session</label>
              <b-form-select v-model="entry.session_id" :options="workLogSessionOptions"
                @change="fillExistingWorkLog(entry)"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group>
          <label class="work-log-label">Description</label>
          <b-form-textarea placeholder="Describe the work done..." :rows="workLogEntries.length > 1 ? 3 : 6"
            max-rows="12" v-model="entry.description"></b-form-textarea>
        </b-form-group>

        <b-row>
          <!-- from and to time: hour and minute, type or use the arrows; AM / PM by button -->
          <b-col md="6" v-for="field in ['from', 'to']" :key="field">
            <b-form-group class="mb-0">
              <label class="work-log-label">{{ field == 'from' ? 'From Time' : 'To Time' }}</label>
              <div class="d-flex align-items-center">
                <b-form-input v-model="entry.timeParts[field].hour" type="number" min="1" max="12" placeholder="Hour"
                  class="work-log-time-part"></b-form-input>
                <span class="mx-1 font-weight-bold">:</span>
                <b-form-input v-model="entry.timeParts[field].minute" type="number" min="0" max="59" placeholder="Min"
                  class="work-log-time-part" @blur="padMinute(entry, field)"></b-form-input>
                <b-button-group class="ml-2">
                  <b-button :variant="entry.timeParts[field].ampm == 'AM' ? 'primary' : 'outline-primary'"
                    @click="entry.timeParts[field].ampm = 'AM'">AM</b-button>
                  <b-button :variant="entry.timeParts[field].ampm == 'PM' ? 'primary' : 'outline-primary'"
                    @click="entry.timeParts[field].ampm = 'PM'">PM</b-button>
                </b-button-group>
                <b-link v-if="entry.timeParts[field].hour !== '' || entry.timeParts[field].minute !== ''" class="ml-2"
                  @click="setTimeParts(entry, field, null)">Clear</b-link>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <button type="button" class="work-log-add-more" :disabled="savingWorkLog" @click="addWorkLogEntry()">
        <i class="fas fa-plus-circle"></i> Add More Work Log
      </button>

      <div class="text-right mt-3">
        <b-button variant="secondary" size="sm" @click="$bvModal.hide('workLogModal')">Cancel</b-button>
        <b-button variant="primary" size="sm" class="ml-2" :disabled="savingWorkLog" @click="saveWorkLog()">
          {{ savingWorkLog ? 'Saving...' : 'Save' }}
        </b-button>
      </div>
    </b-modal>

    <b-modal id="fullScheduleModal" hide-footer title="My Full Schedule" modal-class="usersListPendingFull"
      @hidden="fullSchedule.dateSessionScheduleAtts = {}">
      <div v-if="fullSchedule.loading" class="text-center py-3">Loading Schedules...</div>
      <div v-else-if="fullSchedule.empty" class="text-danger text-center py-2">
        <b>Timetable is not updated by Faculty adviser</b>
      </div>
      <table v-else class="table table-bordered black-border" style="width: auto !important; text-align: center; margin: 0 auto;">
        <thead style="position: sticky; top: 0; z-index: 1;">
          <tr>
            <th class="text-center text-white bg-dark" style="min-width: 100px;">
              <i class="fas fa-user-clock fa-lg"></i>
            </th>
            <th v-for="sessionId in fullSchedule.sessionIds" :key="sessionId" style="width: 150px; min-width: 150px; max-width: 150px;"
              class="text-center text-white bg-dark">
              {{ sessionObjects[sessionId].name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sessionsScheduleAtts, date) in fullSchedule.dateSessionScheduleAtts" :key="date">
            <td>
              {{ moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') }} <br>{{ weekdayNames[new Date(date).getDay()] }}
            </td>
            <td v-for="sessionId in fullSchedule.sessionIds" :key="sessionId" class="schedule-cell">
              <div v-for="(entries, entriesIndex) in [slotEntries(sessionsScheduleAtts[sessionId])]" :key="entriesIndex"
                v-show="entries.length > 0" class="full-schedule-cell" :class="slotEntryBackground(entries[0])">
                <div v-for="(entry, entryIndex) in entries" :key="entryIndex" v-b-popover.hover.top="slotEntryDetails(entry)"
                  class="schedule-cell-label" :class="slotEntryColor(entry)">
                  {{ slotEntryLabel(entry) }}
                  <span v-if="entry.schedule && entry.schedule.swapped == 1" class="schedule-cell-more">(Swapped)</span>
                  <span v-if="entry.schedule && entry.schedule.handover == 1" class="schedule-cell-more">(Session handover)</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
    <b-modal id="studentsAttendanceMarkingFormModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
      hide-footer hide-header-close hide-title modal-class="markAttendence">
      <studentsAttendanceMarkingForm :dataToMarkAttendanceFor="markAttendanceFor"
        @successAttendanceMarkForm="successAttendanceMarkForm" @cancelAttendanceMarkForm="cancelAttendanceMarkForm" />
    </b-modal>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import axios from "axios";
import studentsAttendanceMarkingForm from './studentsAttendanceMarkingForm.vue';
// import moment from "moment";
import customDateAttendanceMarking from './customDateAttendanceMarking.vue';
export default {
  props: ["propSessions"],
  async created() {
    // this.sessions = this.propSessions;
    // if (this.sessions.length < 1) {
    await this.getSessions();
    // } else {
    //   this.sessionObjects = {};
    //   this.sessions.forEach(session => {
    //     this.sessionObjects[session.id] = session;
    //   });
    // }
    await this.getMySchedulesAttendances();
  },
  components: {
    customDateAttendanceMarking,
    studentsAttendanceMarkingForm,
  },
  data() {
    return {
      // slot holding several subjects, waiting for one to be chosen
      slotPicker: { date: null, sessionIds: [], entries: [], chosenIndex: 0 },
      // chosen cells with several subjects (all on one date), the subject is
      // picked on Proceed from the ones common to every chosen session
      pendingSlots: { date: '', sessions: [] },
      start_date : '',
      courseInstructorArray: [],
      swapRequestSave: false,
      facultyOptions: [],
      subgroupOptions: [],
      courseOptions: [],
      mutualSwapFromCourseOptions: [],
      mutualSwapToCourseOptions: [],
      sessionOptions: [],
      mutualswap: {
        to_schedules_length: null,
        from_schedules_length: null,
        selectedFaculty: null,
        selectedSubgroup: null,
        selectedSession: null,
        selectedDate: null,
        selectedCourse: null,
        selectedSubgroupType: null,
        reason: null,
        swapped_session: false,
        selectedFromCourse: null,
        selectedToCourse: null,
        fromslot: null,
        toslot: null,
        from_swap_approval_id: null,
        to_swap_approval_id: null,
        fromstatus: null,
        tostatus: null,
        fromintiated: null,
        tointiated: null,
      },
      sessionhandoverarray: [],
      sessionhandover: {
        selectedFaculty: null,
        selectedclass: null,
        reason: null,
        course_user_ids: [],
        fromslot: null,
        toslot: null,
        from_session_handover_approval_id: null,
        to_session_handover_approval_id: null,
        fromstatus: null,
        tostatus: null,
        fromintiated: null,
        tointiated: null,
      },
      attendenceSwapOptions: [
        { value: 1, text: "All Request" },
        { value: 2, text: "Received Pending Request" },
        { value: 3, text: "Send Pending Request" },
        { value: 4, text: "Action taken received request" },
        { value: 5, text: "Action taken send request" },
      ],
      attendenceSwapArray: [],
      attendenceSwapFilter: 2,
      faculty: null,
      viewMySchedule: null,
      isLoadingMore: null,
      viewLoadMore: false,
      dateSessionScheduleAtts: {},
      courses: {},
      sessions: [],
      sessionObjects: {},
      // id set when editing; time: 'HH:mm' (24 hour)
      workLogEntries: [], // work logs in the add / edit popup, saved together
      workLogEntryKey: 0, // v-for key of the next popup block
      deletingWorkLogId: null,
      // report range, chosen by the user
      workLogReport: { from: '', to: '', loading: false },
      workLogs: {}, // 'date|sessionId' => saved work log
      workLogList: [], // all work logs, newest first
      workLogListLoading: false,
      savingWorkLog: false,
      mySchedulesEnabledSessionIds: [],
      unlock_reason:'',
      // badgeColors: [
      //   'badge-red', 'badge-orange', 'badge-yellow', 'badge-green', 'badge-blue', 'badge-pink', 'badge-purple', 'badge-brown', 'badge-black', 'badge-white'
      // ],
      weekdayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      selectedSlots: {
        student_attendances:[],
        date: '',
        sessions: [],
        course_id: '',
        // confirm_text: '', // pass to att mark form
        already_marked: false,
        holiday: false,
        suspend: false,
        subgroup_type: null,
        lock: false,
        subgroup_id: null,
        unlock_Pending: false,
        swap_pending: false,
        swapped: false,
        handover: false,
        handover_pending: false
      },
      sessionSwapFlags: {}, // sessionId: swap / handover flags of the picked session
      sessionAttendances: {}, // sessionId: student attendances of the picked session, null when not loaded
      markAttendanceFor: { // dedicated to pass data to  attendance mark form from this and other componant
        date: '',
        sessions: [],
        course_id: '',
        confirm_text: '',
        // already_marked: false,
      },
      loadingPdf: false,
      fullSchedule: { loading: false, empty: false, dateSessionScheduleAtts: {}, sessionIds: [] },
      enable_unlock_proceed: true
    };
  },
  validations: {
    mutualswap: {
      selectedFaculty: {
        required,
      },
      selectedSession: {
        required,
      },
      reason: {
        required,
      },
    },
  },
  computed: {
    workLogSessionOptions() {
      return [
        { value: null, text: 'Select Session', disabled: true },
        ...this.sessions.map(session => ({
          value: session.id,
          text: session.time_from && session.time_to
            ? `${session.name} (${session.time_from} - ${session.time_to})`
            : session.name,
        })),
      ];
    },
    filteredSessionHandovers() {
      return this.sessionhandoverarray.filter(attendance => {
        const fromMatch = attendance.fromcourse_user?.some(
          user => user.pivot && user.pivot.faculty === this.mutualswap.faculty
        );

        const toMatch = attendance.tocourse_user?.some(
          user => user.pivot && user.pivot.faculty === this.mutualswap.faculty
        );

        return fromMatch || toMatch;
      });
    },
    mutualswapMinDate() {
      var date = new Date();
      return date;
    },
    mutualswapMaxDate() {
      var date = new Date();
      date.setDate(date.getDate() + 14);
      return date;
    },
  },
  watch: {
    "attendenceSwapFilter": function () {
      this.attendenceSwapList();
    },
  },
  methods: {
    // Subjects of one slot: scheduled ones first, then the ones marked out of schedule.
    slotEntries(slot) {
      if (!slot) return [];
      return [
        ...(slot.schedules || []).map(schedule => ({ courseId: schedule.course_id, schedule })),
        ...(slot.non_schedule_marked_courses || []).map(courseId => ({ courseId, schedule: null })),
      ];
    },
    slotEntryLabel(entry) {
      const course = this.courses[entry.courseId];
      return `${course.code}-${course.usersubgroup.code}`;
    },
    // same colors the legend uses, now on the text instead of a border
    slotEntryColor(entry) {
      if (!entry) return '';
      if (!entry.schedule) return 'text-info';
      if (entry.schedule.attendance_status == 'marked_for_schedule') return 'text-success';
      if (entry.schedule.attendance_status == 'marked_for_schedule_by_someone') return 'text-warning';
      return 'text-danger';
    },
    slotEntryBackground(entry) {
      if (!entry || !entry.schedule) return '';
      return {
        'holiday-schedule': entry.schedule.holiday != null,
        'suspended-schedule': entry.schedule.suspend != null,
      };
    },
    slotEntryStatus(entry) {
      if (!entry.schedule) return 'Not marked from schedule';
      if (entry.schedule.suspend != null) return 'Suspended';
      if (entry.schedule.holiday != null) return 'Holiday';
      if (entry.schedule.attendance_status == 'marked_for_schedule') return 'Marked';
      if (entry.schedule.attendance_status == 'marked_for_schedule_by_someone') return 'Marked by ' + entry.schedule.mark_by_someone;
      return 'Not marked';
    },
    slotEntryDetails(entry) {
      const course = this.courses[entry.courseId];
      const name = course.name + '-' + course.usersubgroup.name + '-' + course.usersubgroup.usergroup.name;
      const scheduleData = entry.schedule;
      if (!scheduleData) {
        return name + ' marked by yourself out of schedule. please use edit attendance at the top to edit this attendance ';
      }
      return (scheduleData.suspend != null ? ' Class Suspended: ' + scheduleData.suspend + ', ' : '') +
        (scheduleData.holiday != null ? 'Holiday: ' + scheduleData.holiday + ', ' : '') +
        (scheduleData.class_type ? scheduleData.class_type + ', ' : '') +
        name +
        (scheduleData.attendance_status == '' ? '' :
          ((scheduleData.attendance_status == 'marked_for_schedule_by_someone' ?
            (' marked by' + scheduleData.mark_by_someone) : ' marked by yourself')));
    },
    // one subject: select it straight away as before; more: the cell is only
    // chosen, Proceed then lets the faculty pick a subject common to all
    // chosen cells
    openSlot(entries, date, sessionId) {
      if (entries.length == 0) return;
      // one subject with a work log opens like a multi subject slot
      if (entries.length == 1 && !this.workLogs[this.workLogKey(date, sessionId)]) {
        // a pending choice this subject can't continue is dropped first
        if (this.pendingSlots.sessions.length > 0) {
          const chosen = this.chosenCourseIds();
          if (this.pendingSlots.date != date || !chosen.includes(`${entries[0].courseId}`)) {
            this.clearPendingSlots();
          }
        }
        this.selectSlotEntry(entries[0], date, sessionId);
        return;
      }
      this.togglePendingSlot(date, sessionId);
    },
    // 422 / 403 / 500 are already shown by the global axios handler
    showRequestError(error) {
      const status = error && error.response && error.response.status;
      if ([403, 422, 500].includes(status)) return;
      this.$toast.error('Request failed, please try again.', { position: 'top', duration: 5000 });
    },
    // A request just sent (unlock / swap / handover) shows as pending on the
    // selected subject's slots right away, instead of only after a refresh.
    markSelectedSchedules(flags) {
      this.selectedSlots.sessions.forEach(sessionId => {
        const schedule = this.slotSchedules(this.selectedSlots.date, sessionId)
          .find(s => `${s.course_id}` == `${this.selectedSlots.course_id}`);
        if (schedule) Object.assign(schedule, flags);
      });
      this.$forceUpdate();
    },
    sessionNames(sessionIds) {
      return (sessionIds || []).map(id => this.sessionObjects[id] ? this.sessionObjects[id].name : '').join(', ');
    },
    isPendingSlot(date, sessionId) {
      return this.pendingSlots.date == date && this.pendingSlots.sessions.includes(sessionId);
    },
    clearPendingSlots() {
      this.pendingSlots.date = '';
      this.pendingSlots.sessions = [];
    },
    slotSchedules(date, sessionId) {
      const slot = this.dateSessionScheduleAtts[date] && this.dateSessionScheduleAtts[date][sessionId];
      return (slot && slot.schedules) || [];
    },
    slotNonScheduledCourseIds(date, sessionId) {
      const slot = this.dateSessionScheduleAtts[date] && this.dateSessionScheduleAtts[date][sessionId];
      return ((slot && slot.non_schedule_marked_courses) || []).map(courseId => `${courseId}`);
    },
    // every subject of a slot, scheduled or marked out of schedule
    slotCourseIds(date, sessionId) {
      return [
        ...this.slotSchedules(date, sessionId).map(schedule => `${schedule.course_id}`),
        ...this.slotNonScheduledCourseIds(date, sessionId),
      ];
    },
    // the subjects that can still be marked for everything chosen so far,
    // null when nothing is chosen
    chosenCourseIds() {
      let courseIds = this.selectedSlots.sessions.length > 0 && this.selectedSlots.course_id !== ''
        ? [`${this.selectedSlots.course_id}`]
        : null;
      this.pendingSlots.sessions.forEach(sessionId => {
        const slotCourseIds = this.slotCourseIds(this.pendingSlots.date, sessionId);
        courseIds = courseIds === null
          ? slotCourseIds
          : courseIds.filter(courseId => slotCourseIds.includes(courseId));
      });
      return courseIds;
    },
    // picked sessions plus the pending ones, in the table's column order
    chosenSessionIds() {
      const sessionIds = [...this.pendingSlots.sessions];
      if (this.selectedSlots.date == this.pendingSlots.date) {
        this.selectedSlots.sessions.forEach(sessionId => {
          if (!sessionIds.includes(sessionId)) sessionIds.push(sessionId);
        });
      }
      return this.mySchedulesEnabledSessionIds.filter(sessionId => sessionIds.includes(sessionId));
    },
    togglePendingSlot(date, sessionId) {
      if (this.isPendingSlot(date, sessionId)) {
        this.pendingSlots.sessions.splice(this.pendingSlots.sessions.indexOf(sessionId), 1);
        if (this.pendingSlots.sessions.length < 1) this.clearPendingSlots();
        this.$forceUpdate();
        return;
      }
      // a cell of another date, or with no subject in common with what's
      // chosen, starts over
      const courseIds = this.slotCourseIds(date, sessionId);
      const chosen = this.chosenCourseIds();
      const chosenDate = this.pendingSlots.date || this.selectedSlots.date;
      if (chosen !== null && (chosenDate != date || !courseIds.some(courseId => chosen.includes(courseId)))) {
        this.clearPendingSlots();
        this.clearSlotSelection();
      }
      this.pendingSlots.date = date;
      this.pendingSlots.sessions.push(sessionId);
      this.$forceUpdate();
    },
    // Proceed with pending cells: the subjects common to every chosen
    // session, each with its lock status gathered from all of them
    openCoursePicker() {
      const date = this.pendingSlots.date;
      const sessionIds = this.chosenSessionIds();
      const commonCourseIds = this.chosenCourseIds() || [];
      // a subject scheduled in some sessions but marked out of schedule in
      // others can't be handled as one, so each kind must hold for all
      const entries = this.slotSchedules(date, this.pendingSlots.sessions[0])
        .filter(schedule => commonCourseIds.includes(`${schedule.course_id}`) &&
          sessionIds.every(sessionId => this.slotSchedules(date, sessionId)
            .some(s => `${s.course_id}` == `${schedule.course_id}`)))
        .map(schedule => {
          const lockedSessions = [];
          const pendingSessions = [];
          const unlockedSessions = [];
          sessionIds.forEach(sessionId => {
            const sessionSchedule = this.slotSchedules(date, sessionId)
              .find(s => `${s.course_id}` == `${schedule.course_id}`);
            if (!sessionSchedule) return;
            if (sessionSchedule.unlocked) unlockedSessions.push(sessionId);
            else if (sessionSchedule.pending) pendingSessions.push(sessionId);
            else if (sessionSchedule.lock) lockedSessions.push(sessionId);
          });
          const lockMixed = [lockedSessions, pendingSessions, unlockedSessions]
            .filter(list => list.length > 0).length > 1 ||
            (lockedSessions.length + pendingSessions.length + unlockedSessions.length > 0 &&
              lockedSessions.length + pendingSessions.length + unlockedSessions.length < sessionIds.length);
          return { courseId: schedule.course_id, schedule, lockedSessions, pendingSessions, unlockedSessions, lockMixed };
        });
      this.slotNonScheduledCourseIds(date, sessionIds[0])
        .filter(courseId => commonCourseIds.includes(courseId) &&
          sessionIds.every(sessionId => this.slotNonScheduledCourseIds(date, sessionId).includes(courseId)))
        .forEach(courseId => {
          entries.push({ courseId, schedule: null, lockedSessions: [], pendingSessions: [], unlockedSessions: [], lockMixed: false });
        });
      if (entries.length < 1) {
        this.$toast.error('No common subject in the selected sessions.', { position: 'top', duration: 3000 });
        return;
      }
      // chosenIndex: the locked subject showing its unlock request, -1 none
      this.slotPicker = { date, sessionIds, entries, chosenIndex: -1 };
      this.$bvModal.show('slotCoursePickerModel');
    },
    // Tapping a subject, like the app: an unlocked one goes straight to
    // marking, a locked one shows (or hides) its unlock request.
    slotEntryClick(entry, entryIndex) {
      if (entry.lockMixed || entry.lockedSessions.length || entry.pendingSessions.length) {
        this.slotPicker.chosenIndex = this.slotPicker.chosenIndex == entryIndex ? -1 : entryIndex;
        return;
      }
      this.slotEntryAction(entry, 'mark');
    },
    // Swap / handover / mark for the ticked subject: select it for every
    // chosen session, then run what the matching header button does.
    slotEntryAction(entry, action) {
      const { date, sessionIds } = this.slotPicker;
      this.$bvModal.hide('slotCoursePickerModel');
      this.clearPendingSlots();
      if (!entry.schedule) {
        if (this.selectedSlots.date != date || `${this.selectedSlots.course_id}` != `${entry.courseId}`) {
          this.clearSlotSelection();
        }
        sessionIds.forEach(sessionId => {
          if (this.selectedSlots.sessions.includes(sessionId)) return;
          this.selectSlotEntry(entry, date, sessionId);
        });
        if (action == 'mark' && this.selectedSlots.sessions.length > 0) this.markNewAttendance();
        return;
      }
      const schedules = sessionIds.map(sessionId => this.slotSchedules(date, sessionId)
        .find(schedule => `${schedule.course_id}` == `${entry.courseId}`));
      // sessions already picked for this subject stay, the rest are added
      if (this.selectedSlots.date != date || `${this.selectedSlots.course_id}` != `${entry.courseId}`) {
        this.clearSlotSelection();
      }
      // marking goes ahead for all of them even when some were swapped /
      // handed over (or have such a request pending)
      const ignoreSwapStatus = action == 'mark';
      sessionIds.forEach((sessionId, index) => {
        if (this.selectedSlots.sessions.includes(sessionId)) return;
        this.selectSlotEntry({ courseId: entry.courseId, schedule: schedules[index] }, date, sessionId, ignoreSwapStatus);
      });
      // an attendance variation was already alerted by selectScheduleSlot
      if (this.selectedSlots.date != date || !sessionIds.every(sessionId => this.selectedSlots.sessions.includes(sessionId))) {
        this.clearSlotSelection();
        this.$forceUpdate();
        return;
      }
      if (action == 'swap') this.showMutualSwapPopup();
      else if (action == 'handover') this.sessionHandover();
      else if (action == 'unlock') this.$bvModal.show('unlockAttendanceModel');
      else this.markNewAttendance();
    },
    slotEntryLocked(entry) {
      return !!(entry && entry.schedule && entry.schedule.lock);
    },
    // Unlock one subject of a multi-subject cell: it alone becomes the
    // selection the existing unlock request is sent for.
    requestSlotEntryUnlock(entry) {
      this.slotEntryAction(entry, 'unlock');
    },
    selectSlotEntry(entry, date, sessionId, ignoreSwapStatus = false) {
      const scheduleData = entry.schedule;
      if (!scheduleData) {
        this.selectScheduleSlot(null, date, sessionId, entry.courseId, 'marked_for_not_scheduled', null, null, false, false,
          this.courses[entry.courseId].usersubgroup.id, null, false, false, false, false);
        return;
      }
      this.selectScheduleSlot(scheduleData['student_attendances'], date, sessionId, scheduleData.course_id,
        scheduleData.attendance_status, scheduleData.holiday != null, scheduleData.suspend != null, scheduleData.lock,
        scheduleData.pending, scheduleData.usersubgroup_id, this.courses[scheduleData.course_id].usersubgroup.type,
        !ignoreSwapStatus && scheduleData.swap_pending, !ignoreSwapStatus && scheduleData.handover_pending,
        !ignoreSwapStatus && scheduleData.swapped, !ignoreSwapStatus && scheduleData.handover);
    },
    localYMD(d) {
      const x = new Date(d)
      return `${x.getFullYear()}-${String(x.getMonth()+1).padStart(2,'0')}-${String(x.getDate()).padStart(2,'0')}`
    },
     async attendenceSwapList() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps?attendenceSwapFilter=${this.attendenceSwapFilter}`;
      try {
        const response = await axios.get(url);
        this.attendenceSwapArray = [];
        this.sessionhandoverarray = [];

        // Set the current faculty ID for the authenticated user
        this.mutualswap.faculty = response.data.faculty;

        // Extract the list of mutual swaps from the response
        const mutualSwaps = response.data.mutual_swap;
        mutualSwaps.forEach((swap) => {
          // Reset all mutual swap properties for each new swap
          Object.assign(this.mutualswap, {
            toslot: null, tostatus: null, tointiated: null, to_swap_approval_id: null,
            fromslot: null, fromstatus: null, fromintiated: null, from_swap_approval_id: null,
          });

          // Iterate through 'fromfaculties' to find relevant details for the current faculty
          swap.fromfaculties.forEach((from) => {
            if (from.faculty === this.mutualswap.faculty) {
              Object.assign(this.mutualswap, {
                fromslot: from.slot, // Slot (0 for "sent", 1 for "received")
                fromstatus: from.approval_status, // Approval status for the "from faculty"
                fromintiated: from.pivot.intiated_by, // Whether the request was initiated by the "from faculty" (1 = initiated)
                from_swap_approval_id: from.pivot.id, // Approval ID for the "from faculty"
              });
            }
          });

          // Iterate through 'tofaculties' to find relevant details for the current faculty
          swap.tofaculties.forEach((to) => {
            if (to.faculty === this.mutualswap.faculty) {
              Object.assign(this.mutualswap, {
                toslot: to.slot, // Slot (0 for "sent", 1 for "received")
                tostatus: to.approval_status, // Approval status for the "to faculty"
                tointiated: to.pivot.intiated_by, // Whether the request was initiated by the "to faculty" (1 = initiated)
                to_swap_approval_id: to.pivot.id, // Approval ID for the "to faculty"
              });
            }
          });

          // Define filter conditions based on the attendance swap filter type
          const filterConditions = [
            // Filter 1: All Requests
            this.attendenceSwapFilter === 1 &&
            ((this.mutualswap.to_swap_approval_id > 0 && swap.approval_status !== 0) || this.mutualswap.from_swap_approval_id > 0),

            // Filter 3: Sending Pending Request
            swap.fromfaculties.length > 0 && this.attendenceSwapFilter === 3 &&
            this.mutualswap.fromintiated === 1 && ([0, 1].includes(swap.approval_status) || this.mutualswap.from_swap_approval_id === null),

            // Filter 5: Action Taken on Sent Requests
            swap.fromfaculties.length > 0 && this.attendenceSwapFilter === 5 &&
            this.mutualswap.fromslot === 0 && this.mutualswap.fromintiated === 1 && ![0, 1].includes(swap.approval_status),

            // Filter 2: Received Pending Request
             swap.tofaculties.length > 0 && this.attendenceSwapFilter === 2 &&
            (swap.approval_status === 1 
            || (this.mutualswap.to_swap_approval_id === null && swap.approval_status === 0)),

            // Filter 4: Action Taken on Received Requests
            this.attendenceSwapFilter === 4 &&
            ((this.mutualswap.to_swap_approval_id && this.mutualswap.tostatus !== 0) ||
              (this.mutualswap.from_swap_approval_id && this.mutualswap.fromstatus !== 0)) &&
            swap.approval_status !== 0 && this.mutualswap.fromintiated !== 1,
          ];

          // If any filter condition matches, add the swap to the attendance swap array
          if (filterConditions.some((condition) => condition)) {
            this.attendenceSwapArray.push({
              id: swap.id, 
              fromfaculties: swap.fromfaculties, 
              fromsubgroup: swap.fromsubgroup, 
              fromcourses: swap.fromcourses, 
              tocourses: swap.tocourses, 
              fromsession: swap.fromsession, 
              from_date: swap.from_date, 
              tofaculties: swap.tofaculties,
              tosubgroup: swap.tosubgroup, 
              tosession: swap.tosession, 
              to_date: swap.to_date, 
              reason: swap.reason, 
              approval_status: swap.approval_status, 
              fromslot: this.mutualswap.fromslot,
              fromstatus: this.mutualswap.fromstatus, 
              fromintiated: this.mutualswap.fromintiated, 
              from_swap_approval_id: this.mutualswap.from_swap_approval_id, 
              toslot: this.mutualswap.toslot, 
              tostatus: this.mutualswap.tostatus, 
              tointiated: this.mutualswap.tointiated, 
              to_swap_approval_id: this.mutualswap.to_swap_approval_id, 
            });
          }
        });

        // Show the attendance swap list modal
        this.$bvModal.show('listAttendenceswapModel');



          var sessionhandover = response.data.session_hand_over;
          sessionhandover.forEach((handover) => {
            handover.fromcourse_user.forEach((from) => {
              if (from.institution_user_id == response.data.faculty) {
                this.sessionhandover.fromslot = from.pivot.slot;
                this.sessionhandover.fromstatus = from.pivot.approval_status;
                this.sessionhandover.fromintiated = from.pivot.intiated_by;
                this.sessionhandover.from_session_handover_approval_id = from.pivot.id;
              }
            });
            handover.tocourse_user.forEach((to) => {
              if (to.institution_user_id == response.data.faculty) {
                this.sessionhandover.toslot = to.pivot.slot;
                this.sessionhandover.tostatus = to.pivot.approval_status;
                this.sessionhandover.tointiated = to.pivot.intiated_by;
                this.sessionhandover.to_session_handover_approval_id = to.pivot.id;
              }
            });
            if ((this.attendenceSwapFilter == 1 && ((this.sessionhandover.to_session_handover_approval_id > 0 && handover.approval_status !=0)|| this.sessionhandover.from_session_handover_approval_id > 0))
              || (handover.fromcourse_user.length > 0 && this.attendenceSwapFilter == 3 && (this.sessionhandover.fromintiated == 1 && (handover.approval_status == 0 || handover.approval_status == 1 || this.sessionhandover.from_session_handover_approval_id == null)))
              || (handover.fromcourse_user.length > 0 && this.attendenceSwapFilter == 5 && (this.sessionhandover.fromslot == 0 && handover.approval_status != 0 && handover.approval_status != 1 && this.sessionhandover.fromintiated == 1))
              || (this.attendenceSwapFilter == 2 && (handover.approval_status == 1 || (this.sessionhandover.to_session_handover_approval_id == null && handover.approval_status == 0)))
              || (handover.tocourse_user.length > 0 && this.attendenceSwapFilter == 4 && (this.sessionhandover.toslot == 1 && handover.approval_status != 0 )&& this.sessionhandoverfromintiated != 1)) {
              this.sessionhandoverarray.push({
                id: handover.id,
                fromcourse_user: handover.fromcourse_user,
                fromsubgroup: handover.fromsubgroup,
                fromsession: handover.fromsession,
                from_date: handover.from_date,
                tocourse_user: handover.tocourse_user,
                reason: handover.reason,
                approval_status: handover.approval_status,
                fromslot: this.sessionhandover.fromslot,
                fromstatus: this.sessionhandover.fromstatus,
                fromintiated: this.sessionhandover.fromintiated,
                from_session_handover_approval_id: this.sessionhandover.from_session_handover_approval_id,
                toslot: this.sessionhandover.toslot,
                tostatus: this.sessionhandover.tostatus,
                tointiated: this.sessionhandover.tointiated,
                to_session_handover_approval_id: this.sessionhandover.to_session_handover_approval_id
              });
            }
          });

      } catch (error) {
        // Log an error message if the API request fails
        console.error('Error fetching attendance swap data:', error);
      }
    },

    async sessionhandoverRequest() {
      try {
        await axios.post(
          this.$store.getters.getAPIKey.mainAPI + "/attendance/sessionhandover",
          {
            from_slot: this.selectedSlots,
            mutualswap: this.mutualswap,
            sessionhandover: this.sessionhandover,
          }
        );
      } catch (error) {
        // keep the popup open so it can be corrected and sent again
        this.showRequestError(error);
        return;
      }
      this.markSelectedSchedules({ handover_pending: 1 });
      this.$toast.success('Session handover request initiated successfully', {
        position: "top",
        duration: 3000,
      });
      this.sessionhandover.course_user_ids = [];
      this.clearSlotSelection();

      this.sessionhandover.selectedFaculty = null;
      this.sessionhandover.selectedclass = null;
      this.sessionhandover.reason = null;
      this.mutualswap.selectedFaculty = null;
      this.mutualswap.selectedclass = null;
      this.mutualswap.selectedsession = null;
      this.mutualswap.selecteddate = null;
      this.mutualswap.selectedcourse = null;
      this.mutualswap.selectedclass_type = null;
      this.mutualswap.reason = null;
      this.mutualswap.sessionlength = null;

      this.$bvModal.hide('mutualswapModal');
      this.$bvModal.hide('sessionHandoverModal');
    },
    updateSessioncourseuserid(course_user_id) {
      if (this.sessionhandover.course_user_ids.includes(course_user_id)) {
        this.sessionhandover.course_user_ids = course_user_id;
      }
    },
     async sessionHandover() {
      this.facultyOptions = [];
      this.classoptions = [];
      this.sessionhandover.selectedFaculty = null;
      this.sessionhandover.selectedclass = null;
      this.sessionhandover.reason = null;
      this.mutualswap.selectedFaculty = null;
      this.mutualswap.selectedclass = null;
      this.mutualswap.selectedsession = null;
      this.mutualswap.selecteddate = null;
      this.mutualswap.selectedcourse = null;
      this.mutualswap.selectedclass_type = null;
      this.mutualswap.reason = null;
      this.mutualswap.sessionlength = null;


      const url1 = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&attendence=1`;
      await axios
        .get(url1)
        .then((response) => {
          this.facultyOptions = response.data;
        })
        .catch((error) => {
          error;
        });

      this.courseInstructorArray = []; //clear
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&`;

      await axios
        .get(url)
        .then((response) => {
          var coursesInstructors = response.data;
          coursesInstructors.forEach((course) => {
            course.institution_users.forEach((instructor) => {
              this.courseInstructorArray.push({
                course_id: course.id,
                course: course.name,
                course_code: course.code,
                instructor: instructor.first_name,
                course_user_deleted_at:instructor.deleted_at,
                instructor_fullname:
                  instructor.first_name + " " + instructor.last_name,
                course_user_id: instructor.course_user_id,
              });
            });
          });
          response;
        })
        .catch((error) => {
          error;
        });
      this.$bvModal.show('sessionHandoverModal');
    },
    async updateSessionhandoverStatus(approval_id, slot, session_hand_over_course, id, status) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendance/sessionhandover/updatestatus`;
      await axios
        .post(
          url,
          {
            session_handover_id: id,
            status: status,
            session_hand_over_course: session_hand_over_course,
            slot: slot,
            session_handover_approval_id: approval_id,
          }
        )
        .then(() => {
          this.$toast.success('Update successfully', {
            position: "top",
            duration: 3000,
          });
          
        })
        this.attendenceSwapList();
    },
    async updateAttendanceSwapStatus(slot, id, status) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/updatestatus`;
      await axios
        .post(
          url,
          {
            attendance_swap_id: id,
            status: status,
            slot: slot,
          }
        )
        .then(() => {
          this.$toast.success('Update successfully', {
            position: "top",
            duration: 3000,
          });
         
        })  
         this.attendenceSwapList(); 
    }, 
    async showMutualSwapPopup() {
      this.resetMutualSwapFields();
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${this.selectedSlots.subgroup_id}/courses/withinstructors?interdepartmental_courses=1&attendence=1`;
      try {
        const response = await axios.get(url);
        this.facultyOptions = response.data;
        this.$bvModal.show('mutualswapModal');
      } catch (error) {
        console.error("Error fetching faculty options:", error);
      }
    },

    resetMutualSwapFields() {
      this.facultyOptions = [];
      this.subgroupOptions = [];
      this.sessionOptions = [];
      Object.assign(this.mutualswap, {
        selectedFaculty: null,
        selectedSubgroup: null,
        selectedSession: null,
        selectedDate: null,
        selectedCourse: null,
        selectedSubgroupType: null,
        reason: null,
        sessionlength: null,
        to_schedules_length: null,
        from_schedules_length: null
      });
    },

    async checkSessionSwapped() {
      const params = {
        session_id: this.mutualswap.selectedSession,
        date: this.mutualswap.selectedDate,
        faculty: this.mutualswap.selectedFaculty
      };
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/checkselected-session-swaps-status`;

      try {
        const response = await axios.get(url, { params });
        this.mutualswap.swapped_session = response.data;
        if(!this.mutualswap.swapped_session){
          this.checkMultipleFaculty();
        }
        
      } catch (error) {
        console.error("Error checking multiple faculty:", error);
      }
    },

     async checkMultipleFaculty() {
      const params = {
        to_session: this.mutualswap.selectedSession,
        to_date: this.mutualswap.selectedDate,
        to_subgroup: this.mutualswap.selectedSubgroup,
        from_date: this.selectedSlots.date,
        from_session: this.selectedSlots.sessions,
        from_subgroup: this.selectedSlots.subgroup_id,
      };
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/checkmultipletofaculties`;
      try {
        const response = await axios.get(url, { params });
        this.mutualswap.to_schedules_length = response.data.to_schedules;
        this.mutualswap.from_schedules_length = response.data.from_schedules;
      } catch (error) {
        console.error("Error checking multiple faculty:", error);
      }
    },

    async mutualUserSubGroupList() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/mutualusersubgroups?faculty=${this.mutualswap.selectedFaculty}`;
      try {
        const response = await axios.get(url);
        this.subgroupOptions = response.data.usersubgroups.map(({ id, name, type }) => ({
          value: id,
          text: name,
          type,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching user subgroups:", error);
      }
    },

    async checkClassType() {
      const selectedSubgroup = this.subgroupOptions.find(
        subgroup => subgroup.value === this.mutualswap.selectedSubgroup
      );
      if (selectedSubgroup) {
        this.mutualswap.selectedSubgroupType = selectedSubgroup.type;
      }

      const url = `${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps/mutualswapcourses?to_faculty=${this.mutualswap.selectedFaculty}&from_usersubgroup=${this.selectedSlots.subgroup_id}&to_usersubgroup=${this.mutualswap.selectedSubgroup}`;
      try {
        const response = await axios.get(url);
        this.mutualSwapFromCourseOptions = response.data.fromCourses.map(({ id, name }) => ({
          value: id,
          text: name,
        })).sort((a, b) => a.text.localeCompare(b.text));

        this.mutualSwapToCourseOptions = response.data.toCourses.map(({ id, name }) => ({
          value: id,
          text: name,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching mutual swap courses:", error);
      }
    },

    async mutualswapSessionlist() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupschedules?usersubgroup=${this.mutualswap.selectedSubgroup}&faculty=${this.mutualswap.selectedFaculty}&date=${this.mutualswap.selectedDate}`;
      try {
        const response = await axios.get(url);
        this.sessionOptions = response.data.map(({ session }) => ({
          value: session.id,
          text: session.name,
        })).sort((a, b) => a.text.localeCompare(b.text));
      } catch (error) {
        console.error("Error fetching session options:", error);
      }
    },

    async initiateSwapRequest() {
      this.swapRequestSave = true;
      await this.$v.$touch();

      if (this.$v.$invalid) {
        const tabHeight = document.getElementById("staffListTab__BV_tab_container_");
        this.$smoothScroll({
          container: tabHeight,
          scrollTo: document.querySelector(".form-group-error"),
          duration: 1000,
          offset: -120,
        });
        this.submitStatus = "ERROR";
        this.swapRequestSave = false;
        return;
      }

      const payload = {
        from_slot: this.selectedSlots,
        mutualswap: this.mutualswap,
        sessionhandover: this.sessionhandover,
      };
      try {
        await axios.post(`${this.$store.getters.getAPIKey.mainAPI}/attendanceswaps`, payload);
        this.markSelectedSchedules({ swap_pending: 1 });
        this.$bvModal.hide('mutualswapModal');
        this.$toast.success("Mutual swap request initiated successfully", {
          position: "top",
          duration: 3000,
        });
        this.resetMutualSwapFields();
        this.clearSlotSelection();
      } catch (error) {
        // keep the popup open so it can be corrected and sent again
        this.showRequestError(error);
      } finally {
        this.swapRequestSave = false;
      }
    },
     async submitattendanceunlock() {
      this.enable_unlock_proceed = false;
      const url = this.$store.getters.getAPIKey.mainAPI + `/attendanceunlocks`;
      await this.$axios
        .post(url, {
          date: this.selectedSlots.date,
          sessions: this.selectedSlots.sessions,
          course: this.selectedSlots.course_id,
          subgroup_id: this.selectedSlots.subgroup_id,
          reason: this.unlock_reason,
          lock: this.selectedSlots.lock
        })
        .then(() => {
          // show the request as pending right away for this subject in the
          // requested sessions, instead of still "locked" until a refresh
          this.markSelectedSchedules({ pending: true });
          this.$toast.success(
            "Attendance unlock request submitted successfully.",
            {
              position: "top",
              duration: 3000,
            }
          );
        })
        .catch((error) => {
          error;
        });
        this.unlock_reason = null;
        this.enable_unlock_proceed = true;
        this.clearSlotSelection()
        this.$bvModal.hide('unlockAttendanceModel');
    },
    async downloadMySchedulePdf() {
      this.loadingPdf = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institutionuser/courseschedules/report/pdfexport`;
      await this.$axios
        .post(
          url, {}, { responseType: "blob" }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "faculty_personal_schedules.pdf");
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.downloadData = false;
        })
        .catch(() => {
          this.$toast.error('Failed to download', {
            position: "top",
            duration: 7000,
          });
        });
      this.loadingPdf = false;
    },
    async downloadWorkLogReport() {
      this.workLogReport.loading = true;
      const { from, to } = this.workLogReport;
      try {
        const response = await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/worklogs/report/pdfexport`,
          { from, to }, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'work_log_report.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$bvModal.hide('workLogReportModal');
      } catch (error) {
        this.$toast.error('Failed to download', { position: 'top', duration: 5000 });
      }
      this.workLogReport.loading = false;
    },
    openEditCourseAttendanceFormWithReportMainTab() {
      // open in Main Content area 
      this.$root.subContent.subContentComponent = "editCourseAttendanceFormWithReport";
      this.$root.subContent.subContentData = {};
      this.$root.subContent.enableMainContent = false;
    },
    markNewAttendanceFromCustomDate(selectedSlots) {
      this.$bvModal.hide('customDateAttendanceMarkModel');
      this.markAttendanceFor = selectedSlots;
      this.$bvModal.show('studentsAttendanceMarkingFormModel');
      // this.$emit('markNewAttendance', selectedSlots)
    },
    markNewAttendance() {
      // this.selectedSlots;
      let tempDate = new Date(this.selectedSlots.date).toLocaleDateString();
      let sessionNames = '';
      let tempCourse = this.courses[this.selectedSlots.course_id];
      this.selectedSlots.sessions.forEach(sessionId => {
        sessionNames += this.sessionObjects[sessionId].name + ', '
      });
      this.selectedSlots.confirm_text = 'Mark attendance for ' +
        tempCourse.name + ' '
        + tempCourse.usersubgroup.code + ' on ' + tempDate + ' and sessions: ' + sessionNames;

      // this.$emit('markNewAttendance', this.selectedSlots)
      this.markAttendanceFor = this.selectedSlots;
      this.$bvModal.show('studentsAttendanceMarkingFormModel');
    },
    // every student has the same attendance type as in the already picked
    // sessions (ones not loaded in the table are skipped)
    sameAsSelectedAttendances(attendances) {
      return Object.values(this.sessionAttendances)
        .filter(picked => picked !== null)
        .every(picked => picked.length === attendances.length &&
          picked.every(ref => attendances.some(att =>
            `${att.attendee_id}` == `${ref.attendee_id}` &&
            `${att.attendance_type_id}` == `${ref.attendance_type_id}`)));
    },
    selectScheduleSlot(student_attendances, date, sessionId, courseId, attendance_status, holiday, suspend, lock, pending, subgroup_id, type, swap_pending, handover_pending, swapped, handover) {
      // clear selection if date/course/flags mismatch
      if (
        (this.selectedSlots.date != date) ||
        (this.selectedSlots.course_id != courseId) ||
        (this.selectedSlots.lock != lock) ||
        (this.selectedSlots.unlock_Pending != pending)
      ) {
        this.clearSlotSelection();
      }

      // toggle session in/out of selection
      if (this.selectedSlots.sessions.includes(sessionId)) {
        this.selectedSlots.sessions.splice(this.selectedSlots.sessions.indexOf(sessionId), 1);
        delete this.sessionAttendances[sessionId];
      } else {
        // locked/pending slots are allowed without validation
        if (!(lock || pending)) {
          // attendance marked out of schedule isn't loaded in the table, the
          // marking form checks it against the other sessions instead
          const attendances = attendance_status == 'marked_for_not_scheduled' ? null : (student_attendances || []);
          if (attendances && !this.sameAsSelectedAttendances(attendances)) {
            alert("Attendance data variation identified across the selected sessions. Please select individual sessions to proceed with editing attendance.");
            return;
          }
          this.sessionAttendances[sessionId] = attendances;
        }
        this.selectedSlots.sessions.push(sessionId);
      }

      // 🔑 Common assignments (always executed)
      this.selectedSlots.student_attendances = student_attendances;
      this.selectedSlots.holiday = holiday;
      this.selectedSlots.suspend = suspend;
      this.selectedSlots.subgroup_id = subgroup_id;
      this.selectedSlots.subgroup_type = type;
      this.selectedSlots.unlock_Pending = pending;
      this.selectedSlots.lock = lock;
      // swapped / handed over sessions can be picked together with others of
      // the same subject; the flags hold if any picked session has them
      if (this.selectedSlots.sessions.includes(sessionId)) {
        this.sessionSwapFlags[sessionId] = { swapped, swap_pending, handover, handover_pending };
      } else {
        delete this.sessionSwapFlags[sessionId];
      }
      const pickedFlags = this.selectedSlots.sessions.map(id => this.sessionSwapFlags[id] || {});
      this.selectedSlots.swapped = pickedFlags.some(f => f.swapped);
      this.selectedSlots.swap_pending = pickedFlags.some(f => f.swap_pending);
      this.selectedSlots.handover = pickedFlags.some(f => f.handover);
      this.selectedSlots.handover_pending = pickedFlags.some(f => f.handover_pending);
      this.selectedSlots.date = date;
      this.selectedSlots.course_id = courseId;
      this.selectedSlots.already_marked = attendance_status !== '';

      if (this.selectedSlots.sessions.length < 1) {
        this.clearSlotSelection();
      }

      this.$forceUpdate();
    },

    clearSlotSelection() {
      this.selectedSlots.student_attendances = [];
      this.selectedSlots.date = '';
      this.selectedSlots.sessions = [];
      this.selectedSlots.course_id = '';
      this.selectedSlots.confirm_text = '';
      this.selectedSlots.already_marked = false;
      this.selectedSlots.holiday = false;
      this.selectedSlots.suspend = false;
      this.selectedSlots.swapped = false;
      this.selectedSlots.swap_pending = false;
      this.selectedSlots.handover = false;
      this.selectedSlots.handover_pending = false;
      this.sessionSwapFlags = {};
      this.sessionAttendances = {};
      this.markAttendanceFor.date = '';
      this.markAttendanceFor.sessions = [];
      this.markAttendanceFor.course_id = '';
      this.markAttendanceFor.confirm_text = '';
      // this.markAttendanceFor.already_marked= false;
    },
    // swap/handover only work for a single session — once the "multiple
    // sessions" note is closed, the selection is dropped
    clearMultiSessionSelection() {
      if (this.selectedSlots.sessions.length > 1) {
        this.clearPendingSlots();
        this.clearSlotSelection();
        this.$forceUpdate();
      }
    },

    // selectNonScheduleSlot(date, sessionId, courseId) {
    //   if (this.selectedSlots.date == date) { // select slot on same date then add / remove session only
    //     if (this.selectedSlots.sessions.includes(sessionId)) {
    //       this.selectedSlots.sessions.splice(this.selectedSlots.sessions.indexOf(sessionId), 1);
    //     } else {
    //       this.selectedSlots.sessions.push(sessionId);
    //     }
    //     if (this.selectedSlots.sessions.length < 1) { // clear all
    //       this.selectedSlots.date = '';
    //       this.selectedSlots.sessions = [];
    //       this.selectedSlots.course_id = '';
    //     }
    //   } else { // selected on a different date then reset date course sessions
    //     this.selectedSlots.date = '';
    //     this.selectedSlots.sessions = [];
    //     this.selectedSlots.course_id = '';

    //     this.selectedSlots.date = date;
    //     this.selectedSlots.sessions = [sessionId];
    //     this.selectedSlots.course_id = courseId;
    //   }
    //   this.$forceUpdate();
    // },
    async getMySchedulesAttendances(append = false) {

      if (this.sessions.length < 1) await this.getSessions();
      this.viewMySchedule = append ? true : null;
      if (!append) {
        this.clearPendingSlots();
        this.dateSessionScheduleAtts = {};
        this.mySchedulesEnabledSessionIds = [];
        this.start_date = '';
      }
      this.isLoadingMore = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupschedules/myschedulesattendances?start_date=${this.start_date}`;
      var responseData = [];
      await this.$axios
        .get(url)
        .then((response) => {
          responseData = response.data;          
        })
        .catch((error) => {
          error;
          this.viewMySchedule = false;
          this.isLoadingMore = false;
        });

      this.isLoadingMore = false;      
      this.viewMySchedule = true;
      if (responseData.emptySchedule && !append)
        this.viewMySchedule = false;

      if(responseData.emptySchedule == false && responseData.min_date < responseData.dateRangeFrom || responseData.emptySchedule == true && responseData.min_date < responseData.dateRangeFrom)
        this.viewLoadMore = true;    
      else
        this.viewLoadMore = false;

      let tempMySchedulesEnabledSessionIds = [];
      for (const date in responseData.dateSessionScheduleAtts) {
        const sessionsData = responseData.dateSessionScheduleAtts[date];
        for (const sessionId in sessionsData) {
          // const sessionData = sessions[sessionId];
          if (!tempMySchedulesEnabledSessionIds.includes(sessionId))
            tempMySchedulesEnabledSessionIds.push(sessionId);
        }
      }

      // reorder schedule sessions ids
      this.mySchedulesEnabledSessionIds = [];
      this.sessions.forEach(session => {
        if (tempMySchedulesEnabledSessionIds.includes(`${session.id}`))
          this.mySchedulesEnabledSessionIds.push(`${session.id}`);
      });      


      Object.assign(this.dateSessionScheduleAtts, responseData.dateSessionScheduleAtts);

      this.courses = {
        ...this.courses,
        ...responseData.courses
      };

      this.start_date = responseData.dateRangeFrom;
      await this.getWorkLogs();
      // setTimeout(() => {
      //   this.scrollToToday()
      // }, 1500);
    },

    workLogKey(date, sessionId) {
      return `${date}|${sessionId}`;
    },
    // work logs for the dates in the schedule table
    async getWorkLogs() {
      const dates = Object.keys(this.dateSessionScheduleAtts).sort();
      if (dates.length < 1) return;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/worklogs?from=${dates[0]}&to=${dates[dates.length - 1]}`;
      try {
        const logs = (await this.$axios.get(url)).data;
        const workLogs = { ...this.workLogs };
        logs.forEach(log => { workLogs[this.workLogKey(log.date, log.session_id)] = log; });
        this.workLogs = workLogs;
        this.addWorkLogSessionColumns();
      } catch (error) {
        error;
      }
    },
    // a work log in a session with no class still gets its column
    addWorkLogSessionColumns() {
      const sessionIds = new Set(this.mySchedulesEnabledSessionIds);
      Object.values(this.workLogs).forEach(log => {
        if (this.dateSessionScheduleAtts[log.date]) sessionIds.add(`${log.session_id}`);
      });
      if (sessionIds.size == this.mySchedulesEnabledSessionIds.length) return;
      this.mySchedulesEnabledSessionIds = this.sessions
        .map(session => `${session.id}`)
        .filter(id => sessionIds.has(id));
    },
    workLogDetails(log) {
      return (log.time ? `Time: ${this.workLogTime(log)}\n` : '') + log.description;
    },
    // '02:30 PM - 03:30 PM', or just the from time when there is no to time
    workLogTime(log) {
      if (!log || !log.time) return '';
      return this.formatTime12(log.time) + (log.to_time ? ' - ' + this.formatTime12(log.to_time) : '');
    },
    // subjects after the first, plus the slot's work log
    slotMoreCount(entries, date, sessionId) {
      return entries.length - 1 + (this.workLogs[this.workLogKey(date, sessionId)] ? 1 : 0);
    },
    // work log added to a single subject's hover details
    slotWorkLogDetails(date, sessionId) {
      const log = this.workLogs[this.workLogKey(date, sessionId)];
      return log ? ' | Work Log: ' + this.workLogDetails(log) : '';
    },
    // '14:30' or '14:30:00' -> '02:30 PM'
    formatTime12(time) {
      if (!time) return '';
      const [hours, minutes] = time.split(':').map(Number);
      const hour12 = hours % 12 || 12;
      return `${String(hour12).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${hours < 12 ? 'AM' : 'PM'}`;
    },
    // full page list of all my work logs
    async openWorkLogList() {
      this.$bvModal.show('workLogListModal');
      if (this.sessions.length < 1) await this.getSessions();
      this.workLogListLoading = this.workLogList.length < 1; // later opens refresh silently
      try {
        const logs = (await this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/worklogs`)).data;
        this.workLogList = logs;
        const workLogs = { ...this.workLogs };
        logs.forEach(log => { workLogs[this.workLogKey(log.date, log.session_id)] = log; });
        this.workLogs = workLogs;
      } catch (error) {
        this.showRequestError(error);
      }
      this.workLogListLoading = false;
    },
    // a blank block of the add / edit popup
    newWorkLogEntry(date = '', sessionId = null) {
      const blankTime = () => ({ hour: '', minute: '', ampm: 'AM' });
      return {
        key: this.workLogEntryKey++,
        id: null,
        date,
        session_id: sessionId ? Number(sessionId) : null,
        description: '',
        timeParts: { from: blankTime(), to: blankTime() },
      };
    },
    // add (no date / session) or edit; date and session given from the list or a schedule cell
    async openWorkLog(date = '', sessionId = null) {
      const entry = this.newWorkLogEntry(date, sessionId);
      this.workLogEntries = [entry];
      this.fillExistingWorkLog(entry);
      this.$bvModal.show('workLogModal');
      if (this.sessions.length < 1) await this.getSessions();
    },
    // another block, on the same date as the last one
    addWorkLogEntry() {
      const last = this.workLogEntries[this.workLogEntries.length - 1];
      this.workLogEntries.push(this.newWorkLogEntry(last ? last.date : ''));
    },
    removeWorkLogEntry(index) {
      this.workLogEntries.splice(index, 1);
    },
    // picking a date and session that already has a log loads it for editing
    fillExistingWorkLog(entry) {
      const log = this.workLogs[this.workLogKey(entry.date, entry.session_id)];
      if (!log) return;
      entry.id = log.id;
      entry.description = log.description;
      this.setTimeParts(entry, 'from', log.time);
      this.setTimeParts(entry, 'to', log.to_time);
    },
    // field 'from' / 'to': '16:05' / '16:05:00' -> 04 : 05 PM; null clears
    setTimeParts(entry, field, time) {
      if (!time) {
        entry.timeParts[field] = { hour: '', minute: '', ampm: 'AM' };
        return;
      }
      const [hours, minutes] = time.split(':').map(Number);
      entry.timeParts[field] = { hour: String(hours % 12 || 12), minute: String(minutes).padStart(2, '0'), ampm: hours < 12 ? 'AM' : 'PM' };
    },
    padMinute(entry, field) {
      const parts = entry.timeParts[field];
      if (parts.minute !== '') parts.minute = String(parts.minute).padStart(2, '0');
    },
    // entered parts of 'from' / 'to' -> 'HH:mm' (24 hour); null when empty, false when invalid
    timeFromParts(entry, field) {
      const { hour, minute, ampm } = entry.timeParts[field];
      if (hour === '' && minute === '') return null;
      const h = Number(hour), m = minute === '' ? 0 : Number(minute);
      if (!Number.isInteger(h) || h < 1 || h > 12 || !Number.isInteger(m) || m < 0 || m > 59) return false;
      const hours24 = (h % 12) + (ampm == 'PM' ? 12 : 0);
      return `${String(hours24).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    },
    // newest date first, then session order
    sortWorkLogList(list) {
      const sessionOrder = id => this.sessions.findIndex(session => session.id == id);
      return list.sort((a, b) => b.date.localeCompare(a.date) || sessionOrder(a.session_id) - sessionOrder(b.session_id));
    },
    // checks every block first, nothing is saved when one is wrong; error message or the payloads
    workLogPayloads() {
      const many = this.workLogEntries.length > 1;
      const payloads = [];
      const slots = new Set();
      for (const [index, entry] of this.workLogEntries.entries()) {
        const which = many ? `Work Log ${index + 1}: ` : '';
        const { date, session_id, description } = entry;
        if (!date || !session_id || !description.trim()) return { error: which + 'Please select date, session and enter description.' };
        const time = this.timeFromParts(entry, 'from');
        const toTime = this.timeFromParts(entry, 'to');
        if (time === false || toTime === false) return { error: which + 'Please enter a valid time (hour 1-12, minute 0-59).' };
        if (toTime && !time) return { error: which + 'Please enter the from time.' };
        if (time && toTime && toTime <= time) return { error: which + 'To time must be after from time.' };
        const slot = this.workLogKey(date, session_id);
        if (slots.has(slot)) return { error: which + 'Another work log here has the same date and session.' };
        slots.add(slot);
        payloads.push({ entry, payload: { date, session_id, description, time, to_time: toTime } });
      }
      return { payloads };
    },
    async saveWorkLog() {
      if (this.workLogEntries.length < 1) {
        this.$bvModal.hide('workLogModal');
        return;
      }
      const { error, payloads } = this.workLogPayloads();
      if (error) {
        this.$toast.error(error, { position: 'top', duration: 3000 });
        return;
      }
      this.savingWorkLog = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/worklogs`;
      let saved = 0;
      // one by one; a failed one stops and stays in the popup, the saved ones leave it
      for (const { entry, payload } of payloads) {
        try {
          const log = (entry.id ? await this.$axios.put(`${url}/${entry.id}`, payload) : await this.$axios.post(url, payload)).data;
          this.applySavedWorkLog(log);
          this.workLogEntries = this.workLogEntries.filter(item => item !== entry);
          saved++;
        } catch (requestError) {
          this.showRequestError(requestError);
          break;
        }
      }
      if (saved > 0) {
        this.addWorkLogSessionColumns();
        this.$toast.success(saved == 1 ? 'Work log saved' : `${saved} work logs saved`, { position: 'top', duration: 3000 });
      }
      if (this.workLogEntries.length < 1) this.$bvModal.hide('workLogModal');
      this.savingWorkLog = false;
    },
    // after a confirm; removed from the list and schedule cells in place
    async deleteWorkLog(log) {
      const date = this.moment(log.date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      const session = this.sessionObjects[log.session_id] ? this.sessionObjects[log.session_id].name : '';
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Delete the work log of ${date}${session ? ', session ' + session : ''}?`,
        { title: 'Delete Work Log', size: 'sm', okVariant: 'danger', okTitle: 'Delete', cancelTitle: 'Cancel', centered: true });
      if (!confirmed) return;
      this.deletingWorkLogId = log.id;
      try {
        await this.$axios.delete(`${this.$store.getters.getAPIKey.mainAPI}/worklogs/${log.id}`);
        const workLogs = { ...this.workLogs };
        Object.keys(workLogs).forEach(key => { if (workLogs[key].id == log.id) delete workLogs[key]; });
        this.workLogs = workLogs;
        this.workLogList = this.workLogList.filter(item => item.id != log.id);
        this.$toast.success('Work log deleted', { position: 'top', duration: 3000 });
      } catch (error) {
        this.showRequestError(error);
      }
      this.deletingWorkLogId = null;
    },
    // update the list and schedule cells in place; an edit may have moved the log to another slot
    applySavedWorkLog(log) {
      const workLogs = { ...this.workLogs };
      Object.keys(workLogs).forEach(key => { if (workLogs[key].id == log.id) delete workLogs[key]; });
      workLogs[this.workLogKey(log.date, log.session_id)] = log;
      this.workLogs = workLogs;
      this.workLogList = this.sortWorkLogList([...this.workLogList.filter(item => item.id != log.id), log]);
    },
    // the whole schedule at once for the full page popup
    async openFullSchedule() {
      this.$bvModal.show('fullScheduleModal');
      if (this.sessions.length < 1) await this.getSessions();
      this.fullSchedule = { loading: true, empty: false, dateSessionScheduleAtts: {}, sessionIds: [] };
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroupschedules/myschedulesattendances?full_schedule=1`;
      let responseData = {};
      try {
        responseData = (await this.$axios.get(url)).data;
      } catch (error) {
        this.showRequestError(error);
      }
      const dateSessionScheduleAtts = responseData.dateSessionScheduleAtts || {};
      const usedSessionIds = [];
      for (const date in dateSessionScheduleAtts) {
        for (const sessionId in dateSessionScheduleAtts[date]) {
          if (!usedSessionIds.includes(sessionId)) usedSessionIds.push(sessionId);
        }
      }
      this.courses = { ...this.courses, ...responseData.courses };
      this.fullSchedule = {
        loading: false,
        empty: !!responseData.emptySchedule || Object.keys(dateSessionScheduleAtts).length < 1,
        dateSessionScheduleAtts,
        sessionIds: this.sessions.map(session => `${session.id}`).filter(id => usedSessionIds.includes(id)),
      };
    },

    async getSessions() {
      this.sessionObjects = {};
      const url = this.$store.getters.getAPIKey.createSessions;
      await this.$axios
        .get(url)
        .then((response) => {
          this.sessions = response.data;
          this.sessions.forEach(session => {
            this.sessionObjects[session.id] = session;
          });
        })
        .catch((error) => {
          error;
        });
    },
    scrollToToday() {
      let el = this.$refs.todaySchedule;
      el.scrollIntoView({ behavior: "smooth" });
    },
    successAttendanceMarkForm() {
      this.$bvModal.hide('studentsAttendanceMarkingFormModel');
      this.clearSlotSelection();
      // this.selectedSlots.date = '';
      // this.selectedSlots.sessions = [];
      // this.selectedSlots.course_id = '';
      // this.markAttendanceFor.date = '';
      // this.markAttendanceFor.sessions = [];
      // this.markAttendanceFor.course_id = '';
    },
    cancelAttendanceMarkForm() {
      this.$bvModal.hide('studentsAttendanceMarkingFormModel');
      this.clearSlotSelection();
      // this.markAttendanceFor.date = '';
      // this.markAttendanceFor.sessions = [];
      // this.markAttendanceFor.course_id = '';
    },
  },
};
</script>

<style  >
/* Work log in a schedule cell */
.schedule-work-log {
  margin-top: 4px;
  padding: 2px 6px;
  font-size: 12px;
  color: #fff;
  background: #6f42c1;
  border-radius: 4px;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slot-picker-work-log {
  border-left: 3px solid #6f42c1 !important;
}

/* Work log popup */
.work-log-time-part {
  width: 80px;
  text-align: center;
}

.work-log-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 6px;
}
/* one block of the work log popup, when it holds more than one */
.work-log-entry {
  background: #f8f9fc;
  border: 1px solid #e3e7f0;
  border-left: 4px solid #007bff;
  border-radius: 10px;
  padding: 14px 16px 16px;
  margin-bottom: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.work-log-entry-head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e3e7f0;
}
.work-log-entry-number {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #007bff;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.work-log-entry-title {
  font-weight: 700;
  color: #343a40;
}
.work-log-entry-tag {
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 12px;
  background: #fff3cd;
  color: #856404;
  font-size: 11px;
  font-weight: 600;
}
.work-log-remove {
  margin-left: auto;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #fdecee;
  color: #dc3545;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.work-log-remove:hover {
  background: #dc3545;
  color: #fff;
}
.work-log-remove i {
  font-size: 13px !important;
}
.work-log-add-more {
  width: 100%;
  margin-top: 4px;
  padding: 10px;
  border: 2px dashed #9ec5fe;
  border-radius: 10px;
  background: #f1f7ff;
  color: #0d6efd;
  font-weight: 600;
  transition: background 0.15s, border-color 0.15s;
}
.work-log-add-more:hover:not(:disabled) {
  background: #e3efff;
  border-color: #0d6efd;
}
.work-log-add-more:disabled {
  opacity: 0.6;
}
.work-log-add-more i {
  font-size: 15px !important;
  margin-right: 6px;
}

body{
  overflow-y: auto;
}
.c-border {
  border: 2px solid;
}

.holiday-schedule {
  background-color: rgb(223, 219, 97);
}

.suspended-schedule {
  background-color: rgb(255, 126, 126);
}

.schedule-cell {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  height: 56px;
  padding: 1px !important;
  vertical-align: middle !important;
}

.schedule-cell-content {
  cursor: pointer;
  height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.schedule-cell-label {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* subject and "+N" on one line */
.schedule-cell-row {
  display: flex;
  justify-content: center;
}

/* long subject names shorten so the count stays visible */
.schedule-cell-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule-cell-count {
  flex-shrink: 0;
  margin-left: 4px;
}

.schedule-cell-more {
  font-size: 11px !important;
  color: #555;
}

.slot-picker-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
  border-radius: 12px;
  cursor: pointer;
}

.slot-picker-card {
  margin-bottom: 10px;
  border: 1px solid #dddddd;
  border-radius: 12px;
}

.slot-picker-card .slot-picker-item {
  margin-bottom: 0;
  border: none;
}

.slot-picker-item-chosen {
  background-color: #eaf2ff;
  border: 1.5px solid #007bff;
}

.full-schedule-cell {
  min-height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.selected-slot {
  background-color: rgb(186, 186, 186) !important;
}

.attendance-table-container{
  height: 100% !important;
}

.black-border th,
.black-border td,
.black-border tr {
  border: 1px solid rgb(175, 175, 175);
}

.blink_me {
  animation: blinker 1.5s linear infinite;
  color: forestgreen;
}
</style>
